/* @ds-bundle: {"format":3,"namespace":"NEOCockpitDesignSystem_04cf2b","components":[{"name":"Button","sourcePath":"components/buttons/Button.jsx"},{"name":"SendButton","sourcePath":"components/buttons/SendButton.jsx"},{"name":"Card","sourcePath":"components/containers/Card.jsx"},{"name":"CollapsibleSection","sourcePath":"components/containers/CollapsibleSection.jsx"},{"name":"DiffView","sourcePath":"components/containers/DiffView.jsx"},{"name":"SplitPanel","sourcePath":"components/containers/SplitPanel.jsx"},{"name":"Tabs","sourcePath":"components/containers/Tabs.jsx"},{"name":"DataTable","sourcePath":"components/data/DataTable.jsx"},{"name":"FilterBar","sourcePath":"components/data/FilterBar.jsx"},{"name":"Pagination","sourcePath":"components/data/Pagination.jsx"},{"name":"Banner","sourcePath":"components/feedback/Banner.jsx"},{"name":"SYSTEM_BANNERS","sourcePath":"components/feedback/Banner.jsx"},{"name":"Dialog","sourcePath":"components/feedback/Dialog.jsx"},{"name":"ConfirmDialog","sourcePath":"components/feedback/Dialog.jsx"},{"name":"Tooltip","sourcePath":"components/feedback/Tooltip.jsx"},{"name":"Checkbox","sourcePath":"components/forms/Checkbox.jsx"},{"name":"FormField","sourcePath":"components/forms/FormField.jsx"},{"name":"Input","sourcePath":"components/forms/Input.jsx"},{"name":"Radio","sourcePath":"components/forms/Radio.jsx"},{"name":"Select","sourcePath":"components/forms/Select.jsx"},{"name":"Switch","sourcePath":"components/forms/Switch.jsx"},{"name":"Textarea","sourcePath":"components/forms/Textarea.jsx"},{"name":"AppShell","sourcePath":"components/navigation/AppShell.jsx"},{"name":"Avatar","sourcePath":"components/navigation/Avatar.jsx"},{"name":"Breadcrumb","sourcePath":"components/navigation/Breadcrumb.jsx"},{"name":"NavItem","sourcePath":"components/navigation/NavItem.jsx"},{"name":"RoleBadge","sourcePath":"components/navigation/RoleBadge.jsx"},{"name":"SearchField","sourcePath":"components/navigation/SearchField.jsx"},{"name":"ConfidenceIndicator","sourcePath":"components/status/ConfidenceIndicator.jsx"},{"name":"EvidenceCallout","sourcePath":"components/status/EvidenceCallout.jsx"},{"name":"StatusPill","sourcePath":"components/status/StatusPill.jsx"},{"name":"Tag","sourcePath":"components/status/Tag.jsx"},{"name":"VersionStamp","sourcePath":"components/status/VersionStamp.jsx"},{"name":"REQUEST_LIFECYCLE","sourcePath":"components/status/statusStyles.js"},{"name":"SEND_STATE","sourcePath":"components/status/statusStyles.js"},{"name":"FACT_STATUS","sourcePath":"components/status/statusStyles.js"},{"name":"TimelineItem","sourcePath":"components/timeline/TimelineItem.jsx"}],"sourceHashes":{"components/buttons/Button.jsx":"32192fc80187","components/buttons/SendButton.jsx":"2957d8701a25","components/containers/Card.jsx":"4601dfa39295","components/containers/CollapsibleSection.jsx":"32ab7bb0cc42","components/containers/DiffView.jsx":"e72d21d9bfa6","components/containers/SplitPanel.jsx":"9afec62feaaf","components/containers/Tabs.jsx":"38f77ac5408c","components/containers/containerStyles.js":"7618c398210e","components/data/DataTable.jsx":"4ca940caccd6","components/data/FilterBar.jsx":"2d295fce598e","components/data/Pagination.jsx":"845da1d87c47","components/data/dataStyles.js":"328c3ce2bf10","components/feedback/Banner.jsx":"aa7e47eb36a0","components/feedback/Dialog.jsx":"46adf526f701","components/feedback/Tooltip.jsx":"6c49fb3414f9","components/feedback/feedbackStyles.js":"4c69c3b88229","components/forms/Checkbox.jsx":"05ece7690bf1","components/forms/FormField.jsx":"525c9acdd60a","components/forms/Input.jsx":"4a6fbdc6e2ea","components/forms/Radio.jsx":"3ef05c73a3d1","components/forms/Select.jsx":"f12ccb32839e","components/forms/Switch.jsx":"e2603f284458","components/forms/Textarea.jsx":"6f27317f9466","components/forms/fieldStyles.js":"27c3b6c582fa","components/navigation/AppShell.jsx":"115942ae1275","components/navigation/Avatar.jsx":"df2b550b6d45","components/navigation/Breadcrumb.jsx":"89d60b4179ea","components/navigation/NavItem.jsx":"c8270be9194f","components/navigation/RoleBadge.jsx":"b27a43456b91","components/navigation/SearchField.jsx":"7c368d273f5f","components/navigation/navStyles.js":"062996306d2c","components/status/ConfidenceIndicator.jsx":"fc5d136d0558","components/status/EvidenceCallout.jsx":"678f2865aca9","components/status/StatusPill.jsx":"b626e8b59421","components/status/Tag.jsx":"84e49d07ce89","components/status/VersionStamp.jsx":"c1391092b528","components/status/statusStyles.js":"e23873c6b211","components/timeline/TimelineItem.jsx":"95deccc46547"},"inlinedExternals":[],"unexposedExports":[{"name":"chevronIcon","sourcePath":"components/containers/containerStyles.js"},{"name":"closeIcon","sourcePath":"components/feedback/feedbackStyles.js"},{"name":"ensureContainerStyles","sourcePath":"components/containers/containerStyles.js"},{"name":"ensureDataStyles","sourcePath":"components/data/dataStyles.js"},{"name":"ensureFeedbackStyles","sourcePath":"components/feedback/feedbackStyles.js"},{"name":"ensureFormStyles","sourcePath":"components/forms/fieldStyles.js"},{"name":"ensureNavStyles","sourcePath":"components/navigation/navStyles.js"},{"name":"ensureStatusStyles","sourcePath":"components/status/statusStyles.js"},{"name":"fbIcons","sourcePath":"components/feedback/feedbackStyles.js"}]} */

(() => {

const __ds_ns = (window.NEOCockpitDesignSystem_04cf2b = window.NEOCockpitDesignSystem_04cf2b || {});

const __ds_scope = {};

(__ds_ns.__errors = __ds_ns.__errors || []);

// components/buttons/Button.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* Inject component CSS once (no CSS-in-JS lib; just a <style> tag). */
let _injected = false;
function ensureStyles() {
  if (_injected || typeof document === "undefined") return;
  _injected = true;
  const css = `
.neo-btn{--_h:var(--control-h);font-family:var(--font-sans);font-weight:var(--weight-semibold);
  font-size:var(--text-sm);line-height:1;display:inline-flex;align-items:center;justify-content:center;
  gap:var(--space-2);height:var(--_h);padding:0 var(--space-4);border-radius:var(--radius-md);
  border:var(--border-width) solid transparent;cursor:pointer;white-space:nowrap;position:relative;
  transition:background var(--motion-fast) var(--ease-standard),border-color var(--motion-fast) var(--ease-standard),
  color var(--motion-fast) var(--ease-standard),box-shadow var(--motion-fast) var(--ease-standard);
  -webkit-font-smoothing:antialiased;text-decoration:none;user-select:none;}
.neo-btn:focus-visible{outline:none;box-shadow:var(--focus-ring-shadow);}
.neo-btn[disabled],.neo-btn[aria-disabled="true"]{cursor:not-allowed;}
.neo-btn--sm{--_h:var(--control-h-sm);font-size:var(--text-caption);padding:0 var(--space-3);}
.neo-btn--lg{--_h:var(--control-h-lg);font-size:var(--text-base);padding:0 var(--space-5);}
.neo-btn--full{display:flex;width:100%;}
.neo-btn--icon{padding:0;width:var(--_h);}

.neo-btn--primary{background:var(--action-primary);color:var(--action-primary-text);}
.neo-btn--primary:hover{background:var(--action-primary-hover);}
.neo-btn--primary:active{background:var(--action-primary-active);}
.neo-btn--primary[disabled]{background:var(--warm-200);color:var(--text-disabled);}

.neo-btn--secondary{background:var(--surface-card);color:var(--navy-700);border-color:var(--border-strong);}
.neo-btn--secondary:hover{background:var(--surface-hover);border-color:var(--navy-400);}
.neo-btn--secondary:active{background:var(--surface-active);}
.neo-btn--secondary[disabled]{color:var(--text-disabled);border-color:var(--border-subtle);background:var(--surface-card);}

.neo-btn--ghost{background:transparent;color:var(--navy-700);}
.neo-btn--ghost:hover{background:var(--surface-hover);}
.neo-btn--ghost:active{background:var(--surface-active);}
.neo-btn--ghost[disabled]{color:var(--text-disabled);background:transparent;}

.neo-btn--destructive{background:var(--action-danger);color:var(--action-danger-text);}
.neo-btn--destructive:hover{background:var(--action-danger-hover);}
.neo-btn--destructive:active{background:var(--action-danger-active);}
.neo-btn--destructive[disabled]{background:var(--warm-200);color:var(--text-disabled);}

.neo-btn__spin{width:1em;height:1em;border-radius:50%;border:2px solid currentColor;border-right-color:transparent;
  animation:neo-btn-spin .6s linear infinite;}
.neo-btn--loading .neo-btn__label,.neo-btn--loading .neo-btn__icon{visibility:hidden;}
.neo-btn__spin-wrap{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;}
@keyframes neo-btn-spin{to{transform:rotate(360deg);}}
@media (prefers-reduced-motion:reduce){.neo-btn__spin{animation:none;}}
`;
  const s = document.createElement("style");
  s.id = "neo-btn-styles";
  s.textContent = css;
  document.head.appendChild(s);
}

/**
 * Button — the primary NEO action primitive.
 * Variants: primary (navy), secondary, ghost, destructive.
 */
function Button({
  variant = "primary",
  size = "md",
  type = "button",
  disabled = false,
  loading = false,
  fullWidth = false,
  iconLeft = null,
  iconRight = null,
  iconOnly = false,
  className = "",
  children,
  ...rest
}) {
  ensureStyles();
  const cls = ["neo-btn", `neo-btn--${variant}`, size !== "md" ? `neo-btn--${size}` : "", fullWidth ? "neo-btn--full" : "", iconOnly ? "neo-btn--icon" : "", loading ? "neo-btn--loading" : "", className].filter(Boolean).join(" ");
  return /*#__PURE__*/React.createElement("button", _extends({
    type: type,
    className: cls,
    disabled: disabled || loading,
    "aria-busy": loading || undefined
  }, rest), iconLeft && /*#__PURE__*/React.createElement("span", {
    className: "neo-btn__icon",
    "aria-hidden": "true",
    style: {
      display: "inline-flex"
    }
  }, iconLeft), !iconOnly && /*#__PURE__*/React.createElement("span", {
    className: "neo-btn__label"
  }, children), iconOnly && /*#__PURE__*/React.createElement("span", {
    className: "neo-btn__icon",
    "aria-hidden": "true",
    style: {
      display: "inline-flex"
    }
  }, children), iconRight && /*#__PURE__*/React.createElement("span", {
    className: "neo-btn__icon",
    "aria-hidden": "true",
    style: {
      display: "inline-flex"
    }
  }, iconRight), loading && /*#__PURE__*/React.createElement("span", {
    className: "neo-btn__spin-wrap"
  }, /*#__PURE__*/React.createElement("span", {
    className: "neo-btn__spin"
  })));
}
Object.assign(__ds_scope, { Button });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/buttons/Button.jsx", error: String((e && e.message) || e) }); }

// components/buttons/SendButton.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
let _injected = false;
function ensureStyles() {
  if (_injected || typeof document === "undefined") return;
  _injected = true;
  const css = `
.neo-send{font-family:var(--font-sans);display:inline-flex;flex-direction:column;gap:var(--space-2);align-items:stretch;}
.neo-send__btn{font-family:var(--font-sans);font-weight:var(--weight-semibold);font-size:var(--text-sm);
  height:var(--control-h-lg);padding:0 var(--space-5);border-radius:var(--radius-md);border:var(--border-width) solid transparent;
  display:inline-flex;align-items:center;justify-content:center;gap:var(--space-2);cursor:pointer;position:relative;
  transition:background var(--motion-fast) var(--ease-standard),box-shadow var(--motion-fast) var(--ease-standard);}
.neo-send__btn:focus-visible{outline:none;box-shadow:var(--focus-ring-shadow);}
/* ready: deliberate primary navy */
.neo-send__btn--ready{background:var(--action-primary);color:var(--action-primary-text);}
.neo-send__btn--ready:hover{background:var(--action-primary-hover);}
/* armed: gold-bordered confirm state — visibly different, demands a second deliberate click */
.neo-send__btn--armed{background:var(--navy-800);color:var(--cream);border-color:var(--cream);
  box-shadow:0 0 0 3px rgba(250,231,191,0.25);}
.neo-send__btn--armed:hover{background:var(--navy-900);}
/* disabled / fail-closed */
.neo-send__btn--locked{background:var(--warm-150);color:var(--text-disabled);cursor:not-allowed;border-color:var(--border-default);}
.neo-send__reason{display:flex;align-items:flex-start;gap:var(--space-2);font-size:var(--text-caption);
  line-height:var(--leading-snug);color:var(--danger-text);}
.neo-send__reason svg{flex:0 0 auto;margin-top:1px;}
.neo-send__hint{font-size:var(--text-caption);color:var(--text-muted);text-align:center;}
.neo-send__armbar{position:absolute;left:0;bottom:0;height:2px;background:var(--cream);border-radius:0 0 var(--radius-md) var(--radius-md);
  animation:neo-send-arm var(--_armms,4000ms) linear forwards;}
@keyframes neo-send-arm{from{width:100%;}to{width:0%;}}
@media (prefers-reduced-motion:reduce){.neo-send__armbar{animation:none;width:100%;}}
`;
  const s = document.createElement("style");
  s.id = "neo-send-styles";
  s.textContent = css;
  document.head.appendChild(s);
}
const LockIcon = /*#__PURE__*/React.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("rect", {
  x: "3",
  y: "11",
  width: "18",
  height: "11",
  rx: "2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 11V7a5 5 0 0 1 10 0v4"
}));
const ShieldIcon = /*#__PURE__*/React.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9 12 2 2 4-4"
}));
const SendIcon = /*#__PURE__*/React.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  d: "m22 2-7 20-4-9-9-4Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 2 11 13"
}));

/**
 * SendButton — the gated, two-step "armed" send for the only outbound action
 * in NEO Cockpit. There is no auto-send: the operator must confirm deliberately.
 * When a precondition is unmet, pass `disabledReason` to fail closed with a
 * visible reason instead of a silent grey-out.
 */
function SendButton({
  label = "E-Mail senden",
  confirmLabel = "Versand bestätigen",
  sendingLabel = "Wird gesendet…",
  hintArmed = "Erneut klicken zum Senden — kein automatischer Versand.",
  hintIdle = "Versand ist eine bewusste, bestätigte Aktion.",
  disabledReason = null,
  armMs = 4000,
  sending = false,
  onSend,
  ...rest
}) {
  ensureStyles();
  const [armed, setArmed] = React.useState(false);
  const timer = React.useRef(null);
  React.useEffect(() => () => clearTimeout(timer.current), []);
  if (disabledReason) {
    return /*#__PURE__*/React.createElement("div", {
      className: "neo-send"
    }, /*#__PURE__*/React.createElement("button", _extends({
      className: "neo-send__btn neo-send__btn--locked",
      disabled: true,
      "aria-disabled": "true"
    }, rest), LockIcon, /*#__PURE__*/React.createElement("span", null, label)), /*#__PURE__*/React.createElement("div", {
      className: "neo-send__reason",
      role: "alert"
    }, LockIcon, /*#__PURE__*/React.createElement("span", null, disabledReason)));
  }
  function disarm() {
    clearTimeout(timer.current);
    setArmed(false);
  }
  function handleClick() {
    if (sending) return;
    if (!armed) {
      setArmed(true);
      timer.current = setTimeout(() => setArmed(false), armMs);
    } else {
      disarm();
      onSend && onSend();
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "neo-send"
  }, /*#__PURE__*/React.createElement("button", _extends({
    className: `neo-send__btn ${armed ? "neo-send__btn--armed" : "neo-send__btn--ready"}`,
    onClick: handleClick,
    onBlur: armed ? disarm : undefined,
    "aria-live": "polite",
    style: {
      "--_armms": `${armMs}ms`
    }
  }, rest), armed ? ShieldIcon : SendIcon, /*#__PURE__*/React.createElement("span", null, sending ? sendingLabel : armed ? confirmLabel : label), armed && !sending && /*#__PURE__*/React.createElement("span", {
    className: "neo-send__armbar"
  })), /*#__PURE__*/React.createElement("div", {
    className: "neo-send__hint"
  }, armed ? hintArmed : hintIdle));
}
Object.assign(__ds_scope, { SendButton });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/buttons/SendButton.jsx", error: String((e && e.message) || e) }); }

// components/containers/containerStyles.js
try { (() => {
/* Shared style injection for NEO container components. */

let _injected = false;
function ensureContainerStyles() {
  if (_injected || typeof document === "undefined") return;
  _injected = true;
  const css = `
/* ---- Card ---- */
.neo-card{font-family:var(--font-sans);background:var(--surface-card);border:var(--border-width) solid var(--border-subtle);
  border-radius:var(--radius-lg);box-shadow:var(--shadow-sm);overflow:hidden;}
.neo-card--flat{box-shadow:none;}
.neo-card--selected{border-color:var(--navy-400);box-shadow:0 0 0 1px var(--navy-400),var(--shadow-sm);}
.neo-card__head{display:flex;align-items:flex-start;gap:var(--space-3);padding:var(--space-4) var(--space-5);
  border-bottom:var(--border-width) solid var(--divider);}
.neo-card__htext{flex:1;min-width:0;}
.neo-card__title{font-size:var(--text-title);font-weight:var(--weight-semibold);color:var(--text-strong);overflow-wrap:anywhere;}
.neo-card__sub{font-size:var(--text-caption);color:var(--text-muted);margin-top:2px;}
.neo-card__actions{flex:0 0 auto;display:flex;gap:var(--space-2);align-items:center;}
.neo-card__body{padding:var(--space-5);}
.neo-card__body--tight{padding:var(--space-4);}
.neo-card__body--none{padding:0;}
.neo-card__foot{padding:var(--space-4) var(--space-5);border-top:var(--border-width) solid var(--divider);
  background:var(--surface-sunken);display:flex;gap:var(--space-2);justify-content:flex-end;align-items:center;}

/* ---- CollapsibleSection ---- */
.neo-collapse{font-family:var(--font-sans);border:var(--border-width) solid var(--border-subtle);
  border-radius:var(--radius-md);background:var(--surface-card);overflow:hidden;}
.neo-collapse__sum{display:flex;align-items:center;gap:var(--space-3);width:100%;text-align:left;cursor:pointer;
  background:none;border:0;font-family:inherit;padding:var(--space-3) var(--space-4);color:var(--text-strong);
  font-size:var(--text-sm);font-weight:var(--weight-semibold);transition:background var(--motion-fast) var(--ease-standard);}
.neo-collapse__sum:hover{background:var(--surface-hover);}
.neo-collapse__sum:focus-visible{outline:none;box-shadow:var(--focus-ring-shadow);}
.neo-collapse__chev{display:inline-flex;color:var(--text-muted);transition:transform var(--motion-base) var(--ease-standard);}
.neo-collapse--open .neo-collapse__chev{transform:rotate(90deg);}
.neo-collapse__count{margin-left:auto;font-size:var(--text-caption);color:var(--text-muted);font-variant-numeric:tabular-nums;}
.neo-collapse__body{padding:var(--space-2) var(--space-4) var(--space-4);font-size:var(--text-sm);
  line-height:var(--leading-normal);color:var(--text-body);border-top:var(--border-width) solid var(--divider);}

/* ---- Tabs ---- */
.neo-tabs{font-family:var(--font-sans);}
.neo-tabs__list{display:flex;gap:var(--space-1);border-bottom:var(--border-width) solid var(--border-default);}
.neo-tab{appearance:none;background:none;border:0;font-family:inherit;cursor:pointer;font-size:var(--text-sm);
  font-weight:var(--weight-medium);color:var(--text-muted);padding:var(--space-3) var(--space-3);position:relative;
  display:inline-flex;align-items:center;gap:var(--space-2);transition:color var(--motion-fast) var(--ease-standard);
  border-bottom:2px solid transparent;margin-bottom:-1px;}
.neo-tab:hover{color:var(--text-strong);}
.neo-tab--active{color:var(--navy-700);font-weight:var(--weight-semibold);border-bottom-color:var(--navy-700);}
.neo-tab:focus-visible{outline:none;box-shadow:var(--focus-ring-shadow);border-radius:var(--radius-xs);}
.neo-tab__badge{font-size:var(--text-micro);font-variant-numeric:tabular-nums;background:var(--surface-sunken);
  color:var(--text-muted);border-radius:var(--radius-pill);padding:0 6px;line-height:16px;}
.neo-tab--active .neo-tab__badge{background:var(--navy-50);color:var(--navy-700);}

/* ---- SplitPanel ---- */
.neo-split{font-family:var(--font-sans);display:grid;grid-template-columns:1fr 1fr;gap:0;
  border:var(--border-width) solid var(--border-subtle);border-radius:var(--radius-lg);overflow:hidden;background:var(--surface-card);}
.neo-split__col{min-width:0;display:flex;flex-direction:column;}
.neo-split__col + .neo-split__col{border-left:var(--border-width) solid var(--divider);}
.neo-split__head{display:flex;align-items:center;gap:var(--space-2);padding:var(--space-3) var(--space-4);
  border-bottom:var(--border-width) solid var(--divider);background:var(--surface-sunken);
  font-size:var(--text-caption);font-weight:var(--weight-semibold);color:var(--text-subtle);}
.neo-split__body{padding:var(--space-4);font-size:var(--text-sm);line-height:var(--leading-normal);color:var(--text-body);overflow:auto;}

/* ---- DiffView ---- */
.neo-diff{font-family:var(--font-sans);border:var(--border-width) solid var(--border-subtle);border-radius:var(--radius-md);
  overflow:hidden;background:var(--surface-card);}
.neo-diff__head{display:flex;align-items:center;gap:var(--space-2);padding:var(--space-2) var(--space-4);
  background:var(--surface-sunken);border-bottom:var(--border-width) solid var(--divider);
  font-size:var(--text-caption);font-weight:var(--weight-semibold);color:var(--text-subtle);}
.neo-diff__body{padding:var(--space-3) var(--space-4);font-size:var(--text-sm);line-height:var(--leading-relaxed);
  color:var(--text-body);overflow-wrap:anywhere;}
.neo-diff ins{background:var(--success-surface);color:var(--success-text);text-decoration:none;
  border-radius:2px;padding:0 2px;box-decoration-break:clone;-webkit-box-decoration-break:clone;}
.neo-diff del{background:var(--danger-surface);color:var(--danger-text);text-decoration:line-through;
  border-radius:2px;padding:0 2px;box-decoration-break:clone;-webkit-box-decoration-break:clone;}
.neo-diff__legend{display:flex;gap:var(--space-4);margin-left:auto;font-weight:var(--weight-medium);}
.neo-diff__legend span{display:inline-flex;align-items:center;gap:4px;}
.neo-diff__sw{width:10px;height:10px;border-radius:2px;}
`;
  const s = document.createElement("style");
  s.id = "neo-container-styles";
  s.textContent = css;
  document.head.appendChild(s);
}
const chevronIcon = /*#__PURE__*/React.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  d: "m9 18 6-6-6-6"
}));
Object.assign(__ds_scope, { ensureContainerStyles, chevronIcon });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/containers/containerStyles.js", error: String((e && e.message) || e) }); }

// components/containers/Card.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Card — the base panel: white surface, warm hairline border, subtle navy
 * shadow. Optional header (title/subtitle/actions), body padding and footer.
 */
function Card({
  title,
  subtitle,
  actions = null,
  footer = null,
  padding = "default",
  flat = false,
  selected = false,
  className = "",
  bodyClassName = "",
  children,
  ...rest
}) {
  __ds_scope.ensureContainerStyles();
  const hasHead = title || subtitle || actions;
  const bodyPad = padding === "none" ? "neo-card__body--none" : padding === "tight" ? "neo-card__body--tight" : "";
  return /*#__PURE__*/React.createElement("section", _extends({
    className: ["neo-card", flat ? "neo-card--flat" : "", selected ? "neo-card--selected" : "", className].filter(Boolean).join(" ")
  }, rest), hasHead && /*#__PURE__*/React.createElement("header", {
    className: "neo-card__head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "neo-card__htext"
  }, title && /*#__PURE__*/React.createElement("div", {
    className: "neo-card__title"
  }, title), subtitle && /*#__PURE__*/React.createElement("div", {
    className: "neo-card__sub"
  }, subtitle)), actions && /*#__PURE__*/React.createElement("div", {
    className: "neo-card__actions"
  }, actions)), children != null && /*#__PURE__*/React.createElement("div", {
    className: `neo-card__body ${bodyPad} ${bodyClassName}`.trim()
  }, children), footer && /*#__PURE__*/React.createElement("footer", {
    className: "neo-card__foot"
  }, footer));
}
Object.assign(__ds_scope, { Card });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/containers/Card.jsx", error: String((e && e.message) || e) }); }

// components/containers/CollapsibleSection.jsx
try { (() => {
/**
 * CollapsibleSection — an expand/collapse panel for secondary detail (e.g. the
 * full fact list, audit log, raw email). Uncontrolled by default.
 */
function CollapsibleSection({
  summary,
  count = null,
  defaultOpen = false,
  open: controlledOpen,
  onToggle,
  className = "",
  children
}) {
  __ds_scope.ensureContainerStyles();
  const [internal, setInternal] = React.useState(defaultOpen);
  const open = controlledOpen != null ? controlledOpen : internal;
  function toggle() {
    if (onToggle) onToggle(!open);
    if (controlledOpen == null) setInternal(o => !o);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: `neo-collapse ${open ? "neo-collapse--open" : ""} ${className}`.trim()
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "neo-collapse__sum",
    "aria-expanded": open,
    onClick: toggle
  }, /*#__PURE__*/React.createElement("span", {
    className: "neo-collapse__chev"
  }, __ds_scope.chevronIcon), /*#__PURE__*/React.createElement("span", null, summary), count != null && /*#__PURE__*/React.createElement("span", {
    className: "neo-collapse__count"
  }, count)), open && /*#__PURE__*/React.createElement("div", {
    className: "neo-collapse__body"
  }, children));
}
Object.assign(__ds_scope, { CollapsibleSection });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/containers/CollapsibleSection.jsx", error: String((e && e.message) || e) }); }

// components/containers/DiffView.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * DiffView — inline diff of generated vs edited text. Pass `parts` as an array
 * of { type: "same"|"ins"|"del", text }, or pass pre-rendered children.
 */
function DiffView({
  parts = null,
  title = "Änderungen am Entwurf",
  showLegend = true,
  className = "",
  children,
  ...rest
}) {
  __ds_scope.ensureContainerStyles();
  return /*#__PURE__*/React.createElement("div", _extends({
    className: `neo-diff ${className}`.trim()
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: "neo-diff__head"
  }, /*#__PURE__*/React.createElement("span", null, title), showLegend && /*#__PURE__*/React.createElement("span", {
    className: "neo-diff__legend"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    className: "neo-diff__sw",
    style: {
      background: "var(--success-surface)",
      border: "1px solid var(--success-border)"
    }
  }), "hinzugef\xFCgt"), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    className: "neo-diff__sw",
    style: {
      background: "var(--danger-surface)",
      border: "1px solid var(--danger-border)"
    }
  }), "entfernt"))), /*#__PURE__*/React.createElement("div", {
    className: "neo-diff__body"
  }, parts ? parts.map((p, i) => p.type === "ins" ? /*#__PURE__*/React.createElement("ins", {
    key: i
  }, p.text) : p.type === "del" ? /*#__PURE__*/React.createElement("del", {
    key: i
  }, p.text) : /*#__PURE__*/React.createElement("span", {
    key: i
  }, p.text)) : children));
}
Object.assign(__ds_scope, { DiffView });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/containers/DiffView.jsx", error: String((e && e.message) || e) }); }

// components/containers/SplitPanel.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * SplitPanel — two labelled columns side by side, e.g. the generated draft next
 * to its deterministic response-plan. Pass header labels + left/right content.
 */
function SplitPanel({
  leftLabel = "Entwurf",
  rightLabel = "Plan",
  leftActions = null,
  rightActions = null,
  left,
  right,
  className = "",
  ...rest
}) {
  __ds_scope.ensureContainerStyles();
  const id = React.useId();
  const leftHeadingId = `${id}-left-heading`;
  const rightHeadingId = `${id}-right-heading`;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: `neo-split ${className}`.trim()
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: "neo-split__col",
    role: "region",
    "aria-labelledby": leftHeadingId
  }, /*#__PURE__*/React.createElement("div", {
    className: "neo-split__head",
    id: leftHeadingId
  }, /*#__PURE__*/React.createElement("span", null, leftLabel), leftActions && /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: "auto"
    }
  }, leftActions)), /*#__PURE__*/React.createElement("div", {
    className: "neo-split__body"
  }, left)), /*#__PURE__*/React.createElement("div", {
    className: "neo-split__col",
    role: "region",
    "aria-labelledby": rightHeadingId
  }, /*#__PURE__*/React.createElement("div", {
    className: "neo-split__head",
    id: rightHeadingId
  }, /*#__PURE__*/React.createElement("span", null, rightLabel), rightActions && /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: "auto"
    }
  }, rightActions)), /*#__PURE__*/React.createElement("div", {
    className: "neo-split__body"
  }, right)));
}
Object.assign(__ds_scope, { SplitPanel });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/containers/SplitPanel.jsx", error: String((e && e.message) || e) }); }

// components/containers/Tabs.jsx
try { (() => {
/**
 * Tabs — horizontal tab navigation with an active underline and optional count
 * badges. Controlled via `value`/`onChange`, or uncontrolled with `defaultValue`.
 */
function Tabs({
  items = [],
  value,
  defaultValue,
  onChange,
  className = "",
  children
}) {
  __ds_scope.ensureContainerStyles();
  const first = defaultValue != null ? defaultValue : items[0] && items[0].value;
  const [internal, setInternal] = React.useState(first);
  const active = value != null ? value : internal;
  function select(v) {
    if (onChange) onChange(v);
    if (value == null) setInternal(v);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: `neo-tabs ${className}`.trim()
  }, /*#__PURE__*/React.createElement("div", {
    className: "neo-tabs__list",
    role: "tablist"
  }, items.map(it => /*#__PURE__*/React.createElement("button", {
    key: it.value,
    type: "button",
    role: "tab",
    "aria-selected": active === it.value,
    className: `neo-tab ${active === it.value ? "neo-tab--active" : ""}`,
    onClick: () => select(it.value)
  }, it.icon && /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    style: {
      display: "inline-flex"
    }
  }, it.icon), it.label, it.badge != null && /*#__PURE__*/React.createElement("span", {
    className: "neo-tab__badge"
  }, it.badge)))), children != null && /*#__PURE__*/React.createElement("div", {
    className: "neo-tabs__panel"
  }, typeof children === "function" ? children(active) : children));
}
Object.assign(__ds_scope, { Tabs });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/containers/Tabs.jsx", error: String((e && e.message) || e) }); }

// components/data/dataStyles.js
try { (() => {
/* Shared style injection for NEO data components (table, filters, pagination). */

let _injected = false;
function ensureDataStyles() {
  if (_injected || typeof document === "undefined") return;
  _injected = true;
  const css = `
/* ---- FilterBar ---- */
.neo-filterbar{font-family:var(--font-sans);display:flex;align-items:center;gap:var(--space-3);flex-wrap:wrap;
  padding:var(--space-3) var(--space-4);background:var(--surface-card);border:var(--border-width) solid var(--border-subtle);
  border-bottom:0;border-radius:var(--radius-lg) var(--radius-lg) 0 0;}
.neo-filterbar__search{position:relative;display:flex;align-items:center;min-width:220px;flex:0 1 280px;}
.neo-filterbar__search svg{position:absolute;left:var(--space-3);color:var(--text-subtle);pointer-events:none;}
.neo-filterbar__search input{font-family:inherit;font-size:var(--text-sm);height:var(--control-h-sm);width:100%;
  padding:0 var(--space-3) 0 calc(var(--space-3)*2 + 16px);border:var(--border-width) solid var(--border-strong);
  border-radius:var(--radius-md);background:var(--surface-card);color:var(--text-body);box-sizing:border-box;}
.neo-filterbar__search input:focus{outline:none;border-color:var(--focus-ring);box-shadow:var(--focus-ring-shadow);}
.neo-filterbar__spacer{flex:1;}
.neo-filterbar__count{font-size:var(--text-caption);color:var(--text-muted);font-variant-numeric:tabular-nums;white-space:nowrap;}
.neo-filterbar__bulk{display:flex;align-items:center;gap:var(--space-3);font-size:var(--text-sm);color:var(--navy-700);
  background:var(--navy-50);border:var(--border-width) solid var(--navy-100);border-radius:var(--radius-md);
  padding:var(--space-1) var(--space-3);}
.neo-filterbar__bulk b{font-variant-numeric:tabular-nums;}

/* ---- Table ---- */
.neo-tablewrap{font-family:var(--font-sans);border:var(--border-width) solid var(--border-subtle);
  border-radius:var(--radius-lg);overflow:hidden;background:var(--surface-card);}
.neo-tablewrap--joined{border-radius:0 0 var(--radius-lg) var(--radius-lg);}
.neo-table{width:100%;border-collapse:collapse;font-size:var(--text-sm);}
.neo-table th{text-align:left;font-size:var(--text-caption);font-weight:var(--weight-semibold);
  color:var(--text-subtle);background:var(--surface-sunken);padding:var(--space-3) var(--space-4);
  border-bottom:var(--border-width) solid var(--border-default);white-space:nowrap;}
.neo-table th.neo-th--sortable{user-select:none;}
.neo-table th .neo-th__in{display:inline-flex;align-items:center;gap:var(--space-1);}
.neo-table th button.neo-th__in{background:none;border:0;padding:0;font:inherit;color:inherit;cursor:pointer;}
.neo-table th button.neo-th__in:hover{color:var(--text-body);}
.neo-table th button.neo-th__in:focus-visible{outline:none;box-shadow:var(--focus-ring-shadow);border-radius:var(--radius-xs);}
.neo-th__arrow{opacity:0;transition:opacity var(--motion-fast);}
.neo-th--active .neo-th__arrow{opacity:1;color:var(--navy-600);}
.neo-table td{padding:var(--space-3) var(--space-4);border-bottom:var(--border-width) solid var(--divider);
  color:var(--text-body);vertical-align:middle;}
.neo-table td.neo-td--num{text-align:right;font-variant-numeric:tabular-nums lining-nums;}
.neo-table tr:last-child td{border-bottom:0;}
.neo-table tbody tr{transition:background var(--motion-fast) var(--ease-standard);}
.neo-table tbody tr:hover{background:var(--surface-hover);}
.neo-table tbody tr[tabindex="0"]{cursor:pointer;}
.neo-table tbody tr[tabindex="0"]:focus-visible{outline:none;box-shadow:inset 0 0 0 2px var(--focus-ring);}
.neo-table tbody tr.neo-row--selected{background:var(--surface-selected);}
.neo-table tbody tr.neo-row--selected:hover{background:var(--surface-active);}
.neo-table .neo-cell-check{width:40px;padding-right:0;}

/* states */
.neo-table__state{padding:var(--space-12) var(--space-6);text-align:center;color:var(--text-muted);}
.neo-table__state-ic{display:inline-flex;color:var(--text-subtle);margin-bottom:var(--space-3);}
.neo-table__state-title{font-size:var(--text-title);font-weight:var(--weight-semibold);color:var(--text-strong);margin-bottom:var(--space-1);}
.neo-table__state-msg{font-size:var(--text-sm);max-width:380px;margin:0 auto var(--space-4);line-height:var(--leading-normal);}
.neo-table__state--error .neo-table__state-ic{color:var(--danger-500);}
.neo-skel{display:block;height:12px;border-radius:var(--radius-xs);
  background:linear-gradient(90deg,var(--warm-150) 0%,var(--warm-100) 50%,var(--warm-150) 100%);
  background-size:200% 100%;animation:neo-shimmer 1.3s linear infinite;}
@keyframes neo-shimmer{from{background-position:200% 0;}to{background-position:-200% 0;}}
@media (prefers-reduced-motion:reduce){.neo-skel{animation:none;}}

/* ---- Pagination ---- */
.neo-pager{font-family:var(--font-sans);display:flex;align-items:center;gap:var(--space-2);
  padding:var(--space-3) var(--space-4);border:var(--border-width) solid var(--border-subtle);border-top:0;
  border-radius:0 0 var(--radius-lg) var(--radius-lg);background:var(--surface-card);}
.neo-pager__info{font-size:var(--text-caption);color:var(--text-muted);font-variant-numeric:tabular-nums;}
.neo-pager__spacer{flex:1;}
.neo-pager__btn{font-family:inherit;font-size:var(--text-sm);height:var(--control-h-sm);min-width:var(--control-h-sm);
  padding:0 var(--space-2);border:var(--border-width) solid var(--border-default);background:var(--surface-card);
  color:var(--text-body);border-radius:var(--radius-sm);cursor:pointer;font-variant-numeric:tabular-nums;
  display:inline-flex;align-items:center;justify-content:center;gap:4px;transition:background var(--motion-fast);}
.neo-pager__btn:hover:not(:disabled){background:var(--surface-hover);}
.neo-pager__btn--active{background:var(--navy-700);color:var(--cream);border-color:var(--navy-700);font-weight:var(--weight-semibold);}
.neo-pager__btn:disabled{color:var(--text-disabled);cursor:not-allowed;}
.neo-pager__ellipsis{color:var(--text-subtle);padding:0 2px;}
`;
  const s = document.createElement("style");
  s.id = "neo-data-styles";
  s.textContent = css;
  document.head.appendChild(s);
}
Object.assign(__ds_scope, { ensureDataStyles });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/data/dataStyles.js", error: String((e && e.message) || e) }); }

// components/data/FilterBar.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SearchIcon = /*#__PURE__*/React.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "11",
  cy: "11",
  r: "7"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21 21-4.3-4.3"
}));

/**
 * FilterBar — the toolbar above a DataTable: search, filter controls, a result
 * count, and a bulk-action strip when rows are selected. Sits flush on the table.
 */
function FilterBar({
  searchValue,
  onSearch,
  searchPlaceholder = "Anfragen durchsuchen…",
  searchAriaLabel = "Suche",
  filters = null,
  count = null,
  selectedCount = 0,
  bulkActions = null,
  className = "",
  ...rest
}) {
  __ds_scope.ensureDataStyles();
  return /*#__PURE__*/React.createElement("div", _extends({
    className: `neo-filterbar ${className}`.trim()
  }, rest), selectedCount > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "neo-filterbar__bulk"
  }, /*#__PURE__*/React.createElement("b", null, selectedCount), /*#__PURE__*/React.createElement("span", null, "ausgew\xE4hlt"), bulkActions && /*#__PURE__*/React.createElement("span", {
    style: {
      display: "inline-flex",
      gap: "var(--space-2)",
      marginLeft: "var(--space-2)"
    }
  }, bulkActions)) : /*#__PURE__*/React.createElement(React.Fragment, null, onSearch !== undefined && /*#__PURE__*/React.createElement("div", {
    className: "neo-filterbar__search"
  }, SearchIcon, /*#__PURE__*/React.createElement("input", {
    type: "search",
    value: searchValue,
    placeholder: searchPlaceholder,
    onChange: e => onSearch && onSearch(e.target.value),
    "aria-label": searchAriaLabel
  })), filters), /*#__PURE__*/React.createElement("div", {
    className: "neo-filterbar__spacer"
  }), count != null && /*#__PURE__*/React.createElement("span", {
    className: "neo-filterbar__count"
  }, count));
}
Object.assign(__ds_scope, { FilterBar });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/data/FilterBar.jsx", error: String((e && e.message) || e) }); }

// components/data/Pagination.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Prev = /*#__PURE__*/React.createElement("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  d: "m15 18-6-6 6-6"
}));
const Next = /*#__PURE__*/React.createElement("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  d: "m9 18 6-6-6-6"
}));
function pageList(current, total) {
  if (total <= 7) return Array.from({
    length: total
  }, (_, i) => i + 1);
  if (current <= 4) return [1, 2, 3, 4, 5, "…", total];
  if (current >= total - 3) return [1, "…", total - 4, total - 3, total - 2, total - 1, total];
  return [1, "…", current - 1, current, current + 1, "…", total];
}

/**
 * Pagination — page controls for a DataTable, with a "x–y von z" info line.
 * Sits flush under the table.
 */
function Pagination({
  page = 1,
  pageCount = 1,
  pageSize,
  total,
  onChange,
  className = "",
  ...rest
}) {
  __ds_scope.ensureDataStyles();
  const from = pageSize ? (page - 1) * pageSize + 1 : null;
  const to = pageSize ? Math.min(page * pageSize, total ?? page * pageSize) : null;
  const go = p => p >= 1 && p <= pageCount && p !== page && onChange && onChange(p);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: `neo-pager ${className}`.trim()
  }, rest), from != null && total != null && /*#__PURE__*/React.createElement("span", {
    className: "neo-pager__info"
  }, from, "\u2013", to, " von ", total), /*#__PURE__*/React.createElement("span", {
    className: "neo-pager__spacer"
  }), /*#__PURE__*/React.createElement("button", {
    className: "neo-pager__btn",
    disabled: page <= 1,
    onClick: () => go(page - 1),
    "aria-label": "Vorherige Seite"
  }, Prev), pageList(page, pageCount).map((p, i) => p === "…" ? /*#__PURE__*/React.createElement("span", {
    key: `e${i}`,
    className: "neo-pager__ellipsis"
  }, "\u2026") : /*#__PURE__*/React.createElement("button", {
    key: p,
    className: `neo-pager__btn ${p === page ? "neo-pager__btn--active" : ""}`,
    "aria-current": p === page ? "page" : undefined,
    onClick: () => go(p)
  }, p)), /*#__PURE__*/React.createElement("button", {
    className: "neo-pager__btn",
    disabled: page >= pageCount,
    onClick: () => go(page + 1),
    "aria-label": "N\xE4chste Seite"
  }, Next));
}
Object.assign(__ds_scope, { Pagination });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/data/Pagination.jsx", error: String((e && e.message) || e) }); }

// components/feedback/feedbackStyles.js
try { (() => {
/* Shared style injection for NEO feedback components. */

let _injected = false;
function ensureFeedbackStyles() {
  if (_injected || typeof document === "undefined") return;
  _injected = true;
  const css = `
/* ---- Banner / alert ---- */
.neo-banner{font-family:var(--font-sans);display:flex;gap:var(--space-3);align-items:flex-start;
  border:var(--border-width) solid;border-radius:var(--radius-md);padding:var(--space-3) var(--space-4);
  font-size:var(--text-sm);line-height:var(--leading-normal);}
.neo-banner__ic{flex:0 0 auto;margin-top:1px;display:inline-flex;}
.neo-banner__body{flex:1;min-width:0;}
.neo-banner__title{font-weight:var(--weight-semibold);color:var(--text-strong);margin-bottom:2px;overflow-wrap:anywhere;}
.neo-banner__msg{color:var(--text-body);overflow-wrap:anywhere;}
.neo-banner__actions{display:flex;gap:var(--space-2);margin-top:var(--space-2);}
.neo-banner__x{flex:0 0 auto;display:inline-flex;cursor:pointer;color:var(--text-subtle);padding:2px;border-radius:var(--radius-xs);margin:-2px -2px 0 0;background:none;border:0;font:inherit;line-height:0;}
.neo-banner__x:focus-visible{outline:none;box-shadow:var(--focus-ring-shadow);}
.neo-banner__x:hover{color:var(--text-strong);background:rgba(0,0,0,0.05);}
.neo-banner.t-info{background:var(--info-surface);border-color:var(--info-border);}
.neo-banner.t-info .neo-banner__ic{color:var(--info-500);}
.neo-banner.t-success{background:var(--success-surface);border-color:var(--success-border);}
.neo-banner.t-success .neo-banner__ic{color:var(--success-500);}
.neo-banner.t-warning{background:var(--warning-surface);border-color:var(--warning-border);}
.neo-banner.t-warning .neo-banner__ic{color:var(--warning-600);}
.neo-banner.t-danger{background:var(--danger-surface);border-color:var(--danger-border);}
.neo-banner.t-danger .neo-banner__ic{color:var(--danger-500);}
/* system / fail-closed: navy, high-authority */
.neo-banner.t-system{background:var(--navy-700);border-color:var(--navy-800);color:var(--text-on-navy);}
.neo-banner.t-system .neo-banner__title{color:var(--cream);}
.neo-banner.t-system .neo-banner__msg{color:var(--text-on-navy-muted);}
.neo-banner.t-system .neo-banner__ic{color:var(--cream);}
.neo-banner.t-system .neo-banner__x{color:var(--text-on-navy-muted);}

/* ---- Tooltip ---- */
.neo-tip{position:relative;display:inline-flex;}
.neo-tip__pop{position:absolute;z-index:var(--z-tooltip);background:var(--navy-800);color:var(--text-on-navy);
  font-size:var(--text-caption);line-height:var(--leading-snug);padding:var(--space-2) var(--space-3);
  border-radius:var(--radius-sm);white-space:nowrap;box-shadow:var(--shadow-md);opacity:0;visibility:hidden;
  transition:opacity var(--motion-fast) var(--ease-standard);pointer-events:none;}
.neo-tip__pop--top{bottom:calc(100% + 8px);left:50%;transform:translateX(-50%);}
.neo-tip__pop--bottom{top:calc(100% + 8px);left:50%;transform:translateX(-50%);}
.neo-tip:hover .neo-tip__pop,.neo-tip:focus-within .neo-tip__pop{opacity:1;visibility:visible;}
.neo-tip__pop::after{content:"";position:absolute;left:50%;transform:translateX(-50%) rotate(45deg);
  width:8px;height:8px;background:var(--navy-800);}
.neo-tip__pop--top::after{bottom:-4px;}.neo-tip__pop--bottom::after{top:-4px;}

/* ---- Dialog ---- */
.neo-dlg__scrim{position:fixed;inset:0;background:var(--scrim);z-index:var(--z-modal);
  display:flex;align-items:center;justify-content:center;padding:var(--space-6);
  opacity:1;transition:opacity 260ms var(--ease-out);}
.neo-dlg{background:var(--surface-card);border-radius:var(--radius-lg);box-shadow:var(--shadow-overlay);
  width:100%;max-width:480px;max-height:90vh;display:flex;flex-direction:column;overflow:hidden;
  opacity:1;transform:translateY(0) scale(1);transform-origin:center;
  transition:opacity 260ms var(--ease-out),transform 260ms var(--ease-out);}
.neo-dlg__scrim[data-state="closing"]{opacity:0;}
.neo-dlg__scrim[data-state="closing"] .neo-dlg{opacity:0;transform:translateY(8px) scale(.98);pointer-events:none;}
.neo-dlg--wide{max-width:640px;}
.neo-dlg__head{display:flex;gap:var(--space-3);align-items:flex-start;padding:var(--space-5) var(--space-5) var(--space-3);}
.neo-dlg__ic{flex:0 0 auto;width:36px;height:36px;border-radius:var(--radius-md);display:inline-flex;
  align-items:center;justify-content:center;}
.neo-dlg__ic.t-danger{background:var(--danger-surface);color:var(--danger-500);}
.neo-dlg__ic.t-warning{background:var(--warning-surface);color:var(--warning-600);}
.neo-dlg__ic.t-navy{background:var(--navy-50);color:var(--navy-700);}
.neo-dlg__htext{flex:1;min-width:0;}
.neo-dlg__title{font-size:var(--text-title);font-weight:var(--weight-semibold);color:var(--text-strong);overflow-wrap:anywhere;}
.neo-dlg__sub{font-size:var(--text-caption);color:var(--text-muted);margin-top:2px;}
.neo-dlg__x{flex:0 0 auto;display:inline-flex;cursor:pointer;color:var(--text-subtle);padding:4px;border:0;background:transparent;border-radius:var(--radius-sm);}
.neo-dlg__x:hover{color:var(--text-strong);background:var(--surface-hover);}
.neo-dlg__x:focus-visible{outline:none;box-shadow:var(--focus-ring-shadow);}
.neo-dlg__body{padding:0 var(--space-5);font-size:var(--text-sm);line-height:var(--leading-normal);color:var(--text-body);overflow:auto;}
.neo-dlg__foot{display:flex;justify-content:flex-end;gap:var(--space-2);padding:var(--space-5);flex-wrap:wrap;}
@starting-style{
  .neo-dlg__scrim[data-state="open"]{opacity:0;}
  .neo-dlg__scrim[data-state="open"] .neo-dlg{opacity:0;transform:translateY(8px) scale(.98);}
}
@media (prefers-reduced-motion:reduce){
  .neo-dlg__scrim,.neo-dlg{transition:opacity 160ms var(--ease-out);}
  .neo-dlg,.neo-dlg__scrim[data-state="closing"] .neo-dlg{transform:none;}
  @starting-style{.neo-dlg__scrim[data-state="open"] .neo-dlg{transform:none;}}
}
`;
  const s = document.createElement("style");
  s.id = "neo-feedback-styles";
  s.textContent = css;
  document.head.appendChild(s);
}

/* Shared inline status icons (line style, currentColor). */
const fbIcons = {
  info: /*#__PURE__*/React.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16v-5M12 8h.01"
  })),
  success: /*#__PURE__*/React.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 12 3 3 5-6"
  })),
  warning: /*#__PURE__*/React.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3 3.6 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.6a2 2 0 0 0-3.4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9v4M12 17h.01"
  })),
  danger: /*#__PURE__*/React.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8v5M12 16h.01"
  })),
  system: /*#__PURE__*/React.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "3",
    y: "11",
    width: "18",
    height: "11",
    rx: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11V7a5 5 0 0 1 10 0v4"
  }))
};
const closeIcon = /*#__PURE__*/React.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 6 6 18M6 6l12 12"
}));
Object.assign(__ds_scope, { ensureFeedbackStyles, fbIcons, closeIcon });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/feedback/feedbackStyles.js", error: String((e && e.message) || e) }); }

// components/feedback/Banner.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Banner — an inline alert. Tones info/success/warning/danger, plus a navy
 * `system` tone for high-authority fail-closed states. Preset the NEO system
 * notices with the SYSTEM_BANNERS map (AI deaktiviert, Versand deaktiviert,
 * Manuelle Prüfung nötig, Zustellung unklar). The close control is a native
 * button; pass `closeLabel` to name it in the operator's language (#890).
 */
function Banner({
  tone = "info",
  title,
  icon,
  onClose,
  closeLabel = "Schlie\xDFen",
  actions = null,
  className = "",
  children,
  ...rest
}) {
  __ds_scope.ensureFeedbackStyles();
  const ic = icon !== undefined ? icon : __ds_scope.fbIcons[tone] || __ds_scope.fbIcons.info;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: `neo-banner t-${tone} ${className}`.trim(),
    role: "alert"
  }, rest), ic && /*#__PURE__*/React.createElement("span", {
    className: "neo-banner__ic",
    "aria-hidden": "true"
  }, ic), /*#__PURE__*/React.createElement("div", {
    className: "neo-banner__body"
  }, title && /*#__PURE__*/React.createElement("div", {
    className: "neo-banner__title"
  }, title), children && /*#__PURE__*/React.createElement("div", {
    className: "neo-banner__msg"
  }, children), actions && /*#__PURE__*/React.createElement("div", {
    className: "neo-banner__actions"
  }, actions)), onClose && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "neo-banner__x",
    "aria-label": closeLabel,
    onClick: onClose
  }, __ds_scope.closeIcon));
}

/** Canonical NEO system / fail-closed notices. */
const SYSTEM_BANNERS = {
  ai_aus: {
    tone: "system",
    title: "AI deaktiviert",
    message: "Die KI-Extraktion ist abgeschaltet (AI_ENABLED = aus). Vorhandene Daten bleiben sichtbar; neue Anfragen werden nicht automatisch analysiert."
  },
  versand_aus: {
    tone: "system",
    title: "Versand deaktiviert — fail-closed",
    message: "Ausgehender E-Mail-Versand ist gesperrt (FOLLOWUP_SEND_ENABLED = aus). Entwürfe können geprüft, aber nicht gesendet werden."
  },
  pruefung: {
    tone: "warning",
    title: "Manuelle Prüfung nötig",
    message: "Mindestens ein Fakt ist ohne Beleg oder steht im Widerspruch. Bitte vor Freigabe prüfen."
  },
  zustellung: {
    tone: "danger",
    title: "Zustellung unklar",
    message: "Für eine zuletzt gesendete E-Mail liegt keine Zustellbestätigung vor. Status manuell verifizieren."
  }
};
Object.assign(__ds_scope, { Banner, SYSTEM_BANNERS });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/feedback/Banner.jsx", error: String((e && e.message) || e) }); }

// components/feedback/Dialog.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const DIALOG_EXIT_MS = 260;
const DIALOG_REDUCED_EXIT_MS = 160;
const DIALOG_FOCUSABLE = [
  "button:not([disabled])",
  "a[href]",
  "input:not([disabled])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "[contenteditable='true']",
  "[tabindex]:not([tabindex='-1'])"
].join(",");
function dialogFocusable(root) {
  if (!root) return [];
  return Array.from(root.querySelectorAll(DIALOG_FOCUSABLE)).filter(element => {
    if (!(element instanceof HTMLElement) || element.tabIndex < 0) return false;
    if (element.matches(":disabled") || element.closest("[hidden],[aria-hidden='true']")) return false;
    const style = window.getComputedStyle(element);
    return style.display !== "none" && style.visibility !== "hidden" && element.getClientRects().length > 0;
  });
}
function focusDialogElement(element) {
  if (!element || typeof element.focus !== "function") return;
  try {
    element.focus({ preventScroll: true });
  } catch {
    element.focus();
  }
}
/**
 * Dialog — a modal over a navy scrim with header (optional tone icon), body and
 * footer actions. Controlled via `open`. Use the `tone` icon for warning/danger
 * confirmations.
 */
function Dialog({
  open = true,
  keepMounted = false,
  onClose,
  title,
  subtitle,
  tone = null,
  icon = null,
  footer = null,
  wide = false,
  closeButton = true,
  className = "",
  initialFocusRef = null,
  finalFocusRef = null,
  children
}) {
  __ds_scope.ensureFeedbackStyles();
  const [rendered, setRendered] = React.useState(open);
  const [phase, setPhase] = React.useState(open ? "open" : "closed");
  const dialogRef = React.useRef(null);
  const openerRef = React.useRef(null);
  const exitTimerRef = React.useRef(null);
  const focusFrameRef = React.useRef(null);
  const cycleActiveRef = React.useRef(false);
  const openRef = React.useRef(open);
  const phaseRef = React.useRef(phase);
  const onCloseRef = React.useRef(onClose);
  const finalFocusRefRef = React.useRef(finalFocusRef);
  const contentRef = React.useRef(null);
  const closeRequestedRef = React.useRef(false);
  const titleId = React.useId();
  openRef.current = open;
  phaseRef.current = phase;
  onCloseRef.current = onClose;
  finalFocusRefRef.current = finalFocusRef;
  if ((open && !closeRequestedRef.current) || (keepMounted && !rendered) || contentRef.current === null) {
    contentRef.current = {
      title,
      subtitle,
      tone,
      icon,
      footer,
      wide,
      closeButton,
      className,
      hasCloseHandler: typeof onClose === "function",
      children
    };
  }
  const content = contentRef.current;

  const restoreOpener = () => {
    const requested = finalFocusRefRef.current && finalFocusRefRef.current.current;
    const opener = requested && requested.isConnected ? requested : openerRef.current;
    if (opener && opener.isConnected) focusDialogElement(opener);
  };
  const requestClose = () => {
    if (!openRef.current || phaseRef.current !== "open") return;
    if (typeof onCloseRef.current === "function") {
      closeRequestedRef.current = true;
      try {
        onCloseRef.current();
      } finally {
        queueMicrotask(() => {
          if (openRef.current) closeRequestedRef.current = false;
        });
      }
    }
  };
  const completeClose = () => {
    if (openRef.current) return;
    if (exitTimerRef.current !== null) window.clearTimeout(exitTimerRef.current);
    exitTimerRef.current = null;
    setRendered(false);
    setPhase("closed");
    cycleActiveRef.current = false;
    closeRequestedRef.current = false;
    openerRef.current = null;
  };

  React.useEffect(() => {
    if (open) {
      closeRequestedRef.current = false;
      if (!cycleActiveRef.current) {
        cycleActiveRef.current = true;
        openerRef.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      }
      if (exitTimerRef.current !== null) window.clearTimeout(exitTimerRef.current);
      exitTimerRef.current = null;
      setRendered(true);
      setPhase("open");
      return;
    }
    if (!rendered) {
      setPhase("closed");
      return;
    }
    setPhase("closing");
    restoreOpener();
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const duration = reduced ? DIALOG_REDUCED_EXIT_MS : DIALOG_EXIT_MS;
    exitTimerRef.current = window.setTimeout(completeClose, duration + 50);
    return () => {
      if (exitTimerRef.current !== null) window.clearTimeout(exitTimerRef.current);
      exitTimerRef.current = null;
    };
  }, [open, rendered]);

  React.useEffect(() => {
    if (!rendered || !open || phase !== "open") return;
    if (focusFrameRef.current !== null) window.cancelAnimationFrame(focusFrameRef.current);
    focusFrameRef.current = window.requestAnimationFrame(() => {
      focusFrameRef.current = null;
      const dialog = dialogRef.current;
      if (!dialog || !openRef.current || phaseRef.current !== "open") return;
      if (dialog.contains(document.activeElement)) return;
      const explicit = initialFocusRef && initialFocusRef.current;
      const bodyTarget = dialogFocusable(dialog.querySelector(".neo-dlg__body"))[0];
      const footerTarget = dialogFocusable(dialog.querySelector(".neo-dlg__foot"))[0];
      const firstTarget = dialogFocusable(dialog)[0];
      focusDialogElement(
        explicit && dialog.contains(explicit) ? explicit : bodyTarget || footerTarget || firstTarget || dialog
      );
    });
    return () => {
      if (focusFrameRef.current !== null) window.cancelAnimationFrame(focusFrameRef.current);
      focusFrameRef.current = null;
    };
  }, [rendered, open, phase, initialFocusRef]);

  React.useEffect(() => {
    if (!rendered) return;
    const handleKeyDown = event => {
      if (phaseRef.current !== "open" || !openRef.current) return;
      if (event.key === "Escape") {
        event.preventDefault();
        event.stopPropagation();
        requestClose();
        return;
      }
      if (event.key !== "Tab") return;
      const dialog = dialogRef.current;
      if (!dialog) return;
      const focusable = dialogFocusable(dialog);
      if (focusable.length === 0) {
        event.preventDefault();
        focusDialogElement(dialog);
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const active = document.activeElement;
      if (event.shiftKey && (active === first || !dialog.contains(active))) {
        event.preventDefault();
        focusDialogElement(last);
      } else if (!event.shiftKey && (active === last || !dialog.contains(active))) {
        event.preventDefault();
        focusDialogElement(first);
      }
    };
    document.addEventListener("keydown", handleKeyDown, true);
    return () => document.removeEventListener("keydown", handleKeyDown, true);
  }, [rendered]);

  React.useEffect(() => () => {
    if (exitTimerRef.current !== null) window.clearTimeout(exitTimerRef.current);
    if (focusFrameRef.current !== null) window.cancelAnimationFrame(focusFrameRef.current);
    if (cycleActiveRef.current) restoreOpener();
  }, []);

  // Request details retain unfinished form input between openings. Hidden content must neither
  // participate in focus traversal nor keep the dialog's keyboard listener active.
  if (!rendered && !keepMounted) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "neo-dlg__scrim",
    hidden: !rendered,
    style: !rendered ? { display: "none" } : undefined,
    "data-state": phase,
    "aria-hidden": !rendered || phase === "closing" ? "true" : undefined,
    inert: !rendered || phase === "closing" ? "" : undefined,
    onClick: e => e.target === e.currentTarget && requestClose(),
    onTransitionEnd: e => {
      if (e.target === e.currentTarget && e.propertyName === "opacity" && phaseRef.current === "closing") {
        completeClose();
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    ref: dialogRef,
    className: `neo-dlg ${content.wide ? "neo-dlg--wide" : ""} ${content.className}`.trim(),
    role: "dialog",
    "aria-modal": "true",
    "aria-labelledby": content.title ? titleId : undefined,
    tabIndex: -1
  }, /*#__PURE__*/React.createElement("div", {
    className: "neo-dlg__head"
  }, content.icon && /*#__PURE__*/React.createElement("span", {
    className: `neo-dlg__ic t-${content.tone || "navy"}`,
    "aria-hidden": "true"
  }, content.icon), /*#__PURE__*/React.createElement("div", {
    className: "neo-dlg__htext"
  }, content.title && /*#__PURE__*/React.createElement("div", {
    className: "neo-dlg__title",
    id: titleId
  }, content.title), content.subtitle && /*#__PURE__*/React.createElement("div", {
    className: "neo-dlg__sub"
  }, content.subtitle)), content.closeButton && content.hasCloseHandler && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "neo-dlg__x",
    "aria-label": "Schlie\xDFen",
    disabled: !open || phase !== "open",
    onClick: requestClose
  }, __ds_scope.closeIcon)), content.children && /*#__PURE__*/React.createElement("div", {
    className: "neo-dlg__body"
  }, content.children), content.footer && /*#__PURE__*/React.createElement("div", {
    className: "neo-dlg__foot"
  }, content.footer)));
}
const WarnIcon = /*#__PURE__*/React.createElement("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.3 3.6 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.6a2 2 0 0 0-3.4 0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 9v4M12 17h.01"
}));

/**
 * ConfirmDialog — the reusable pattern for confirming an irreversible or
 * OUTBOUND action. For a real send it embeds the gated SendButton so the
 * dialog itself cannot trigger an unconfirmed send.
 */
function ConfirmDialog({
  open = true,
  onClose,
  title = "Aktion bestätigen",
  subtitle,
  tone = "danger",
  confirmLabel = "Bestätigen",
  cancelLabel = "Abbrechen",
  onConfirm,
  outbound = false,
  sendProps = {},
  children
}) {
  return /*#__PURE__*/React.createElement(Dialog, {
    open: open,
    onClose: onClose,
    title: title,
    subtitle: subtitle,
    tone: tone,
    icon: WarnIcon,
    footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(__ds_scope.Button, {
      variant: "ghost",
      onClick: onClose
    }, cancelLabel), outbound ? /*#__PURE__*/React.createElement(__ds_scope.SendButton, _extends({
      onSend: onConfirm
    }, sendProps)) : /*#__PURE__*/React.createElement(__ds_scope.Button, {
      variant: tone === "danger" ? "destructive" : "primary",
      onClick: onConfirm
    }, confirmLabel))
  }, children);
}
Object.assign(__ds_scope, { Dialog, ConfirmDialog });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/feedback/Dialog.jsx", error: String((e && e.message) || e) }); }

// components/feedback/Tooltip.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Tooltip — a small hover/focus hint on navy. Wrap the trigger element.
 * CSS-driven (no portal) — suitable for short, non-interactive content.
 */
function Tooltip({
  content,
  placement = "top",
  className = "",
  children,
  ...rest
}) {
  __ds_scope.ensureFeedbackStyles();
  return /*#__PURE__*/React.createElement("span", _extends({
    className: `neo-tip ${className}`.trim()
  }, rest), children, /*#__PURE__*/React.createElement("span", {
    className: `neo-tip__pop neo-tip__pop--${placement}`,
    role: "tooltip"
  }, content));
}
Object.assign(__ds_scope, { Tooltip });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/feedback/Tooltip.jsx", error: String((e && e.message) || e) }); }

// components/forms/fieldStyles.js
try { (() => {
/* Shared style injection for NEO form controls. Not a component (no .d.ts);
   bundled as a module and imported by the form primitives. */

let _injected = false;
function ensureFormStyles() {
  if (_injected || typeof document === "undefined") return;
  _injected = true;
  const css = `
/* ---- field shell (label / helper / error) ---- */
.neo-field{font-family:var(--font-sans);display:flex;flex-direction:column;gap:var(--space-2);}
.neo-field__label{font-size:var(--text-sm);font-weight:var(--weight-semibold);color:var(--text-strong);
  display:flex;align-items:center;gap:var(--space-2);}
.neo-field__req{color:var(--danger-500);font-weight:var(--weight-bold);}
.neo-field__opt{font-weight:var(--weight-regular);color:var(--text-subtle);font-size:var(--text-caption);}
.neo-field__helper{font-size:var(--text-caption);color:var(--text-muted);line-height:var(--leading-snug);}
.neo-field__msg{font-size:var(--text-caption);line-height:var(--leading-snug);display:flex;align-items:flex-start;gap:var(--space-1);}
.neo-field__msg--error{color:var(--danger-text);}
.neo-field__msg--success{color:var(--success-text);}

/* ---- text input / textarea / select ---- */
.neo-input{font-family:var(--font-sans);font-size:var(--text-base);color:var(--text-body);
  background:var(--surface-card);border:var(--border-width) solid var(--border-strong);
  border-radius:var(--radius-md);height:var(--control-h);padding:0 var(--space-3);width:100%;
  box-sizing:border-box;transition:border-color var(--motion-fast) var(--ease-standard),box-shadow var(--motion-fast) var(--ease-standard);
  font-variant-numeric:tabular-nums lining-nums;}
.neo-input::placeholder{color:var(--text-subtle);}
.neo-input:hover{border-color:var(--navy-400);}
.neo-input:focus{outline:none;border-color:var(--focus-ring);box-shadow:var(--focus-ring-shadow);}
.neo-input:disabled{background:var(--surface-sunken);color:var(--text-disabled);cursor:not-allowed;border-color:var(--border-subtle);}
.neo-input--sm{height:var(--control-h-sm);font-size:var(--text-sm);}
.neo-input--textarea{height:auto;min-height:88px;padding:var(--space-3);line-height:var(--leading-normal);resize:vertical;overflow-wrap:anywhere;}
.neo-input--error{border-color:var(--danger-500);}
.neo-input--error:focus{box-shadow:0 0 0 3px rgba(178,58,46,0.30);}

.neo-inwrap{position:relative;display:flex;align-items:center;}
.neo-inwrap__icon{position:absolute;left:var(--space-3);display:inline-flex;color:var(--text-subtle);pointer-events:none;}
.neo-inwrap__icon--r{left:auto;right:var(--space-3);}
.neo-inwrap--icon .neo-input{padding-left:calc(var(--space-3)*2 + 18px);}
.neo-inwrap--icon-r .neo-input{padding-right:calc(var(--space-3)*2 + 18px);}

.neo-select{appearance:none;-webkit-appearance:none;background-image:none;cursor:pointer;padding-right:calc(var(--space-3)*2 + 14px);}
.neo-select-wrap{position:relative;}
.neo-select-wrap__chev{position:absolute;right:var(--space-3);top:50%;transform:translateY(-50%);pointer-events:none;color:var(--text-muted);display:inline-flex;}

/* ---- checkbox & radio ---- */
.neo-choice{display:inline-flex;align-items:flex-start;gap:var(--space-2);font-family:var(--font-sans);
  font-size:var(--text-base);color:var(--text-body);cursor:pointer;line-height:var(--leading-snug);}
.neo-choice input{position:absolute;opacity:0;width:1px;height:1px;}
.neo-choice__box{flex:0 0 auto;width:18px;height:18px;border:var(--border-width-2) solid var(--border-strong);
  background:var(--surface-card);display:inline-flex;align-items:center;justify-content:center;color:transparent;
  transition:all var(--motion-fast) var(--ease-standard);margin-top:1px;}
.neo-choice__box--cb{border-radius:var(--radius-xs);}
.neo-choice__box--rd{border-radius:var(--radius-pill);}
.neo-choice:hover .neo-choice__box{border-color:var(--navy-500);}
.neo-choice input:checked + .neo-choice__box{background:var(--navy-700);border-color:var(--navy-700);color:var(--cream);}
.neo-choice__box--rd .neo-choice__dot{width:8px;height:8px;border-radius:50%;background:var(--cream);transform:scale(0);transition:transform var(--motion-fast) var(--ease-out);}
.neo-choice input:checked + .neo-choice__box--rd .neo-choice__dot{transform:scale(1);}
.neo-choice input:focus-visible + .neo-choice__box{box-shadow:var(--focus-ring-shadow);}
.neo-choice input:disabled + .neo-choice__box{background:var(--surface-sunken);border-color:var(--border-subtle);}
.neo-choice--disabled{color:var(--text-disabled);cursor:not-allowed;}

/* ---- switch (feature flags) ---- */
.neo-switch{display:inline-flex;align-items:center;gap:var(--space-3);font-family:var(--font-sans);
  font-size:var(--text-base);color:var(--text-body);cursor:pointer;}
.neo-switch input{position:absolute;opacity:0;width:1px;height:1px;}
.neo-switch__track{flex:0 0 auto;width:40px;height:23px;border-radius:var(--radius-pill);background:var(--warm-300);
  position:relative;transition:background var(--motion-base) var(--ease-standard);}
.neo-switch__thumb{position:absolute;top:2.5px;left:2.5px;width:18px;height:18px;border-radius:50%;background:#fff;
  box-shadow:var(--shadow-sm);transition:transform var(--motion-base) var(--ease-standard);}
.neo-switch input:checked + .neo-switch__track{background:var(--success-500);}
.neo-switch input:checked + .neo-switch__track .neo-switch__thumb{transform:translateX(17px);}
.neo-switch input:focus-visible + .neo-switch__track{box-shadow:var(--focus-ring-shadow);}
.neo-switch input:disabled + .neo-switch__track{opacity:0.5;}
.neo-switch--disabled{color:var(--text-disabled);cursor:not-allowed;}
.neo-switch__state{font-size:var(--text-caption);font-weight:var(--weight-semibold);font-variant-numeric:tabular-nums;}
`;
  const s = document.createElement("style");
  s.id = "neo-form-styles";
  s.textContent = css;
  document.head.appendChild(s);
}
/* #890: a field's programmatic state has to reach the real control, not whatever
   wrapper happens to sit around it. FormField publishes its wiring here and each
   control claims it on render, so a control nested inside layout markup is still
   labelled and described. It lives in the shared module rather than in FormField so
   the controls can read it even if FormField itself failed to load. */
const FormFieldContext = React.createContext(null);

/* Merge a field's wiring into a control's own props. Anything the caller set
   explicitly wins — this only fills in what nobody has decided. */
function applyFieldWiring(field, rest) {
  if (!field) return rest;
  const wired = Object.assign({}, rest);
  if (wired.id === undefined && field.controlId) wired.id = field.controlId;
  // Additive, never replacing: a control that already describes itself keeps that
  // description and gains the field's helper or error text alongside it.
  const described = [rest["aria-describedby"], field.describedBy].filter(Boolean).join(" ");
  if (described) wired["aria-describedby"] = described;
  if (rest["aria-invalid"] === undefined && field.invalid) wired["aria-invalid"] = true;
  // aria-required only, never the native `required` attribute: this announces the
  // field's state without changing when the browser lets a form submit.
  if (rest["aria-required"] === undefined && field.required) wired["aria-required"] = true;
  return wired;
}
Object.assign(__ds_scope, { ensureFormStyles, FormFieldContext, applyFieldWiring });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/fieldStyles.js", error: String((e && e.message) || e) }); }

// components/forms/Checkbox.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Check = /*#__PURE__*/React.createElement("svg", {
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 6 9 17l-5-5"
}));

/**
 * Checkbox — a single labelled checkbox. Use for multi-select and boolean opts.
 */
function Checkbox({
  label,
  disabled = false,
  className = "",
  id,
  ...rest
}) {
  __ds_scope.ensureFormStyles();
  return /*#__PURE__*/React.createElement("label", {
    className: `neo-choice ${disabled ? "neo-choice--disabled" : ""} ${className}`.trim()
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "checkbox",
    disabled: disabled,
    id: id
  }, rest)), /*#__PURE__*/React.createElement("span", {
    className: "neo-choice__box neo-choice__box--cb"
  }, Check), label && /*#__PURE__*/React.createElement("span", {
    className: "neo-choice__label"
  }, label));
}
Object.assign(__ds_scope, { Checkbox });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Checkbox.jsx", error: String((e && e.message) || e) }); }

// components/data/DataTable.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const ArrowUp = /*#__PURE__*/React.createElement("svg", {
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  d: "m18 15-6-6-6 6"
}));
const ArrowDown = /*#__PURE__*/React.createElement("svg", {
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2.2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  d: "m6 9 6 6 6-6"
}));
function StateBlock({
  variant,
  icon,
  title,
  message,
  action,
  colSpan,
  role
}) {
  return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: colSpan,
    style: {
      padding: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: `neo-table__state ${variant ? `neo-table__state--${variant}` : ""}`,
    role: role
  }, icon && /*#__PURE__*/React.createElement("div", {
    className: "neo-table__state-ic",
    "aria-hidden": "true"
  }, icon), title && /*#__PURE__*/React.createElement("div", {
    className: "neo-table__state-title"
  }, title), message && /*#__PURE__*/React.createElement("div", {
    className: "neo-table__state-msg"
  }, message), action)));
}

/**
 * DataTable — the cockpit list. Columns + rows, with optional sort, bulk-select
 * (checkbox column + header select-all), and built-in loading skeleton, empty
 * and error states. Joins flush under a FilterBar when `joined`. Loading sets
 * aria-busy, the empty and error states announce themselves, and a sortable
 * column header is a real button (#890).
 */
function DataTable({
  columns = [],
  rows = [],
  rowKey = (r, i) => r.id ?? i,
  // selection
  selectable = false,
  selectedKeys = [],
  onSelect,
  // (key, checked) => void
  onSelectAll,
  // (checked) => void
  onRowClick,
  rowAriaLabel,
  // sort
  sort = null,
  // { key, dir: "asc"|"desc" }
  onSort,
  // (key) => void
  // states
  loading = false,
  skeletonRows = 5,
  error = null,
  // string | node
  onRetry,
  errorTitle = "Daten konnten nicht geladen werden",
  retryLabel = "Erneut versuchen",
  emptyTitle = "Keine Einträge",
  emptyMessage = "Für die aktuellen Filter gibt es keine Anfragen.",
  emptyAction = null,
  selectAllLabel = "Alle ausw\xE4hlen",
  selectRowLabel = "Zeile ausw\xE4hlen",
  joined = false,
  className = "",
  ...rest
}) {
  __ds_scope.ensureDataStyles();
  const clickableRows = typeof onRowClick === "function";
  const totalCols = columns.length + (selectable ? 1 : 0);
  const allSelected = selectable && rows.length > 0 && rows.every((r, i) => selectedKeys.includes(rowKey(r, i)));
  const someSelected = selectable && !allSelected && rows.some((r, i) => selectedKeys.includes(rowKey(r, i)));
  return /*#__PURE__*/React.createElement("div", _extends({
    className: `neo-tablewrap ${joined ? "neo-tablewrap--joined" : ""} ${className}`.trim(),
    // #890: the skeleton says "updating" to anyone who can see it. aria-busy says the
    // same thing to anyone who cannot, so the two audiences learn it at the same time.
    "aria-busy": loading || undefined
  }, rest), /*#__PURE__*/React.createElement("table", {
    className: "neo-table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, selectable && /*#__PURE__*/React.createElement("th", {
    scope: "col",
    className: "neo-cell-check"
  }, /*#__PURE__*/React.createElement(__ds_scope.Checkbox, {
    checked: allSelected,
    ref: el => el && (el.indeterminate = someSelected),
    "aria-label": selectAllLabel,
    onChange: e => onSelectAll && onSelectAll(e.target.checked)
  })), columns.map(c => {
    const active = sort && sort.key === c.key;
    return /*#__PURE__*/React.createElement("th", {
      key: c.key,
      scope: "col",
      style: {
        width: c.width,
        textAlign: c.align === "right" ? "right" : undefined
      },
      className: [c.sortable ? "neo-th--sortable" : "", active ? "neo-th--active" : ""].filter(Boolean).join(" "),
      "aria-sort": active ? sort.dir === "asc" ? "ascending" : "descending" : undefined
      // #890: the click handler used to sit on the <th>, which no keyboard can reach.
      // A sortable column now carries a real button; a plain column stays a plain cell.
    }, /*#__PURE__*/React.createElement(c.sortable ? "button" : "span", {
      type: c.sortable ? "button" : undefined,
      className: "neo-th__in",
      onClick: c.sortable ? () => onSort && onSort(c.key) : undefined,
      style: {
        justifyContent: c.align === "right" ? "flex-end" : undefined
      }
    }, c.header, c.sortable && /*#__PURE__*/React.createElement("span", {
      className: "neo-th__arrow",
      "aria-hidden": "true"
    }, active && sort.dir === "asc" ? ArrowUp : ArrowDown)));
  }))), /*#__PURE__*/React.createElement("tbody", null, loading && Array.from({
    length: skeletonRows
  }).map((_, ri) => /*#__PURE__*/React.createElement("tr", {
    key: `sk-${ri}`
  }, selectable && /*#__PURE__*/React.createElement("td", {
    className: "neo-cell-check"
  }, /*#__PURE__*/React.createElement("span", {
    className: "neo-skel",
    style: {
      width: 18,
      height: 18,
      borderRadius: 4
    }
  })), columns.map((c, ci) => /*#__PURE__*/React.createElement("td", {
    key: c.key,
    className: c.align === "right" ? "neo-td--num" : ""
  }, /*#__PURE__*/React.createElement("span", {
    className: "neo-skel",
    style: {
      width: ci === 0 ? "70%" : `${40 + (ri + ci) % 3 * 15}%`
    }
  }))))), !loading && error && /*#__PURE__*/React.createElement(StateBlock, {
    variant: "error",
    role: "alert",
    colSpan: totalCols,
    icon: /*#__PURE__*/React.createElement("svg", {
      width: "32",
      height: "32",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/React.createElement("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 8v5M12 16h.01"
    })),
    title: errorTitle,
    message: typeof error === "string" ? error : error,
    action: onRetry && /*#__PURE__*/React.createElement("button", {
      className: "neo-pager__btn",
      onClick: onRetry
    }, retryLabel)
  }), !loading && !error && rows.length === 0 && /*#__PURE__*/React.createElement(StateBlock, {
    role: "status",
    colSpan: totalCols,
    icon: /*#__PURE__*/React.createElement("svg", {
      width: "32",
      height: "32",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M3 7h18M3 12h18M3 17h10"
    })),
    title: emptyTitle,
    message: emptyMessage,
    action: emptyAction
  }), !loading && !error && rows.map((r, i) => {
    const key = rowKey(r, i);
    const sel = selectable && selectedKeys.includes(key);
    const label = typeof rowAriaLabel === "function" ? rowAriaLabel(r, i) : rowAriaLabel;
    const openRow = () => onRowClick && onRowClick(r, i);
    const isInteractiveTarget = target => target && target.closest && target.closest("a,button,input,select,textarea,label,[role='button']");
    const onRowClickHandler = e => {
      if (isInteractiveTarget(e.target)) return;
      openRow();
    };
    const onRowKeyDown = e => {
      if (!clickableRows || isInteractiveTarget(e.target)) return;
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        openRow();
      }
    };
    return /*#__PURE__*/React.createElement("tr", {
      key: key,
      className: [sel ? "neo-row--selected" : "", clickableRows ? "neo-row--clickable" : ""].filter(Boolean).join(" "),
      tabIndex: clickableRows ? 0 : undefined,
      "aria-label": clickableRows ? label : undefined,
      onClick: clickableRows ? onRowClickHandler : undefined,
      onKeyDown: clickableRows ? onRowKeyDown : undefined
    }, selectable && /*#__PURE__*/React.createElement("td", {
      className: "neo-cell-check"
    }, /*#__PURE__*/React.createElement(__ds_scope.Checkbox, {
      checked: sel,
      "aria-label": selectRowLabel,
      onChange: e => onSelect && onSelect(key, e.target.checked)
    })), columns.map(c => /*#__PURE__*/React.createElement("td", {
      key: c.key,
      "data-label": typeof c.header === "string" ? c.header : undefined,
      className: c.align === "right" ? "neo-td--num" : ""
    }, c.cell ? c.cell(r, i) : r[c.key])));
  }))));
}
Object.assign(__ds_scope, { DataTable });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/data/DataTable.jsx", error: String((e && e.message) || e) }); }

// components/forms/FormField.jsx
try { (() => {
const Alert = /*#__PURE__*/React.createElement("svg", {
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 8v5M12 16h.01"
}));

/**
 * FormField — label + optional helper + inline validation wrapper for any
 * NEO form control. Owns the control's id and publishes label, helper, error and
 * validation state to it, so the visible field and the programmatic one cannot
 * disagree (#890). Exactly one control per field.
 */
function FormField({
  label,
  htmlFor,
  required = false,
  optional = false,
  optionalLabel = "(optional)",
  helper,
  error,
  success,
  className = "",
  children
}) {
  __ds_scope.ensureFormStyles();
  // #890: the field owns the control's id unless the caller has already named one.
  // Before this, a field without an explicit htmlFor rendered a label pointing at
  // nothing and helper text no screen reader ever reached — which looks identical to a
  // correct field from the outside, and was the state of most fields in the Cockpit.
  const generatedId = React.useId();
  const controlId = htmlFor || generatedId;
  const invalid = Boolean(error);
  const helperId = helper && !error ? `${controlId}-helper` : null;
  const errorId = error ? `${controlId}-error` : null;
  const successId = success && !error ? `${controlId}-success` : null;
  const describedBy = [helperId, errorId, successId].filter(Boolean).join(" ") || null;
  const wiring = React.useMemo(() => ({
    controlId,
    describedBy,
    invalid,
    required
  }), [controlId, describedBy, invalid, required]);
  return /*#__PURE__*/React.createElement("div", {
    className: `neo-field ${className}`.trim()
  }, label && /*#__PURE__*/React.createElement("label", {
    className: "neo-field__label",
    htmlFor: controlId
  }, label, required && /*#__PURE__*/React.createElement("span", {
    className: "neo-field__req",
    "aria-hidden": "true"
  }, "*"), optional && !required && /*#__PURE__*/React.createElement("span", {
    className: "neo-field__opt"
  }, optionalLabel)), /*#__PURE__*/React.createElement(__ds_scope.FormFieldContext.Provider, {
    value: wiring
  }, children), helper && !error && /*#__PURE__*/React.createElement("div", {
    className: "neo-field__helper",
    id: helperId
  }, helper), error && /*#__PURE__*/React.createElement("div", {
    className: "neo-field__msg neo-field__msg--error",
    id: errorId,
    role: "alert"
  }, Alert, /*#__PURE__*/React.createElement("span", null, error)), success && !error && /*#__PURE__*/React.createElement("div", {
    className: "neo-field__msg neo-field__msg--success",
    id: successId
  }, success));
}
Object.assign(__ds_scope, { FormField });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/FormField.jsx", error: String((e && e.message) || e) }); }

// components/forms/Input.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Input — single-line text field with optional leading/trailing icon, error
 * state and a small size. Tabular figures on by default (counts, prices, PLZ).
 */
function Input({
  size = "md",
  error = false,
  iconLeft = null,
  iconRight = null,
  className = "",
  ...rest
}) {
  __ds_scope.ensureFormStyles();
  const wired = __ds_scope.applyFieldWiring(React.useContext(__ds_scope.FormFieldContext), rest);
  const input = /*#__PURE__*/React.createElement("input", _extends({
    className: ["neo-input", size === "sm" ? "neo-input--sm" : "", error ? "neo-input--error" : "", className].filter(Boolean).join(" "),
    "aria-invalid": error || undefined
  }, wired));
  if (!iconLeft && !iconRight) return input;
  return /*#__PURE__*/React.createElement("div", {
    className: `neo-inwrap ${iconLeft ? "neo-inwrap--icon" : ""} ${iconRight ? "neo-inwrap--icon-r" : ""}`.trim()
  }, iconLeft && /*#__PURE__*/React.createElement("span", {
    className: "neo-inwrap__icon",
    "aria-hidden": "true"
  }, iconLeft), input, iconRight && /*#__PURE__*/React.createElement("span", {
    className: "neo-inwrap__icon neo-inwrap__icon--r",
    "aria-hidden": "true"
  }, iconRight));
}
Object.assign(__ds_scope, { Input });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Input.jsx", error: String((e && e.message) || e) }); }

// components/forms/Radio.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Radio — a single labelled radio button. Group several with the same `name`.
 */
function Radio({
  label,
  disabled = false,
  className = "",
  ...rest
}) {
  __ds_scope.ensureFormStyles();
  return /*#__PURE__*/React.createElement("label", {
    className: `neo-choice ${disabled ? "neo-choice--disabled" : ""} ${className}`.trim()
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "radio",
    disabled: disabled
  }, rest)), /*#__PURE__*/React.createElement("span", {
    className: "neo-choice__box neo-choice__box--rd"
  }, /*#__PURE__*/React.createElement("span", {
    className: "neo-choice__dot"
  })), label && /*#__PURE__*/React.createElement("span", {
    className: "neo-choice__label"
  }, label));
}
Object.assign(__ds_scope, { Radio });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Radio.jsx", error: String((e && e.message) || e) }); }

// components/forms/Select.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Chevron = /*#__PURE__*/React.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  d: "m6 9 6 6 6-6"
}));

/**
 * Select — a styled native select (combobox). Reliable, accessible, keyboard
 * friendly. Pass <option> children or an `options` array of {value,label}.
 */
function Select({
  size = "md",
  error = false,
  options = null,
  placeholder = null,
  className = "",
  children,
  ...rest
}) {
  __ds_scope.ensureFormStyles();
  const wired = __ds_scope.applyFieldWiring(React.useContext(__ds_scope.FormFieldContext), rest);
  return /*#__PURE__*/React.createElement("div", {
    className: "neo-select-wrap"
  }, /*#__PURE__*/React.createElement("select", _extends({
    className: ["neo-input", "neo-select", size === "sm" ? "neo-input--sm" : "", error ? "neo-input--error" : "", className].filter(Boolean).join(" "),
    "aria-invalid": error || undefined
  }, wired), placeholder && /*#__PURE__*/React.createElement("option", {
    value: "",
    disabled: true
  }, placeholder), options ? options.map(o => /*#__PURE__*/React.createElement("option", {
    key: o.value,
    value: o.value
  }, o.label)) : children), /*#__PURE__*/React.createElement("span", {
    className: "neo-select-wrap__chev"
  }, Chevron));
}
Object.assign(__ds_scope, { Select });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Select.jsx", error: String((e && e.message) || e) }); }

// components/forms/Switch.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Switch — toggle for feature flags (AI_ENABLED, FOLLOWUP_SEND_ENABLED, …).
 * Shows an explicit AN/AUS state label so the flag reads unambiguously.
 */
function Switch({
  label,
  checked,
  disabled = false,
  showState = true,
  onLabel = "AN",
  offLabel = "AUS",
  className = "",
  ...rest
}) {
  __ds_scope.ensureFormStyles();
  return /*#__PURE__*/React.createElement("label", {
    className: `neo-switch ${disabled ? "neo-switch--disabled" : ""} ${className}`.trim()
  }, /*#__PURE__*/React.createElement("input", _extends({
    type: "checkbox",
    role: "switch",
    checked: checked,
    disabled: disabled
  }, rest)), /*#__PURE__*/React.createElement("span", {
    className: "neo-switch__track"
  }, /*#__PURE__*/React.createElement("span", {
    className: "neo-switch__thumb"
  })), label && /*#__PURE__*/React.createElement("span", {
    className: "neo-switch__lbl"
  }, label), showState && /*#__PURE__*/React.createElement("span", {
    className: "neo-switch__state",
    style: {
      color: checked ? "var(--success-text)" : "var(--text-muted)"
    }
  }, checked ? onLabel : offLabel));
}
Object.assign(__ds_scope, { Switch });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Switch.jsx", error: String((e && e.message) || e) }); }

// components/forms/Textarea.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Textarea — multi-line input for notes and draft text. Wraps long German
 * compound words safely; vertically resizable.
 */
function Textarea({
  error = false,
  rows = 4,
  className = "",
  ...rest
}) {
  __ds_scope.ensureFormStyles();
  const wired = __ds_scope.applyFieldWiring(React.useContext(__ds_scope.FormFieldContext), rest);
  return /*#__PURE__*/React.createElement("textarea", _extends({
    rows: rows,
    className: ["neo-input", "neo-input--textarea", error ? "neo-input--error" : "", className].filter(Boolean).join(" "),
    "aria-invalid": error || undefined
  }, wired));
}
Object.assign(__ds_scope, { Textarea });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/Textarea.jsx", error: String((e && e.message) || e) }); }

// components/navigation/navStyles.js
try { (() => {
/* Shared style injection for NEO navigation / identity components. */

let _injected = false;
function ensureNavStyles() {
  if (_injected || typeof document === "undefined") return;
  _injected = true;
  const css = `
/* ---- AppShell ---- */
.neo-shell{font-family:var(--font-sans);display:grid;grid-template-columns:248px 1fr;grid-template-rows:auto 1fr;
  grid-template-areas:"brand header" "side main";height:100%;min-height:0;background:var(--surface-page);}
.neo-shell__brand{grid-area:brand;background:var(--shell-deep);color:var(--cream);display:flex;align-items:center;
  gap:var(--space-3);padding:0 var(--space-5);height:60px;border-bottom:var(--border-width) solid var(--shell-border);
  border-right:var(--border-width) solid var(--shell-border);}
.neo-shell__brand-neo{font-size:var(--text-h3);font-weight:var(--weight-bold);letter-spacing:3px;line-height:1;}
.neo-shell__brand-sub{font-size:9px;font-weight:var(--weight-medium);letter-spacing:3px;opacity:0.72;margin-top:2px;}
.neo-shell__header{grid-area:header;background:var(--shell-base);color:var(--text-on-navy);display:flex;align-items:center;
  gap:var(--space-4);padding:0 var(--space-5);height:60px;border-bottom:var(--border-width) solid var(--shell-border);}
.neo-shell__side{grid-area:side;background:var(--shell-base);border-right:var(--border-width) solid var(--shell-border);
  padding:var(--space-4) var(--space-3);display:flex;flex-direction:column;gap:var(--space-1);overflow-y:auto;}
.neo-shell__side-group{font-size:var(--text-caption);font-weight:var(--weight-semibold);
  color:var(--text-on-navy-subtle);padding:var(--space-3) var(--space-3) var(--space-1);}
.neo-shell__main{grid-area:main;overflow:auto;padding:var(--space-6);min-width:0;}
.neo-shell__spacer{flex:1;}

/* ---- NavItem ---- */
.neo-nav{display:flex;align-items:center;gap:var(--space-3);width:100%;text-align:left;background:none;border:0;
  font-family:inherit;cursor:pointer;color:var(--text-on-navy-muted);font-size:var(--text-sm);font-weight:var(--weight-medium);
  padding:var(--space-3) var(--space-3);border-radius:var(--radius-md);transition:background var(--motion-fast) var(--ease-standard),color var(--motion-fast) var(--ease-standard);text-decoration:none;}
.neo-nav:hover{background:var(--shell-hover);color:var(--text-on-navy);}
.neo-nav:focus-visible{outline:none;box-shadow:var(--focus-ring-on-navy);}
.neo-nav--active{background:var(--shell-selected);color:var(--cream);font-weight:var(--weight-semibold);
  box-shadow:inset 2px 0 0 var(--cream);}
.neo-nav__ic{flex:0 0 auto;display:inline-flex;opacity:0.92;}
.neo-nav--active .neo-nav__ic{opacity:1;}
.neo-nav__label{flex:1;min-width:0;overflow-wrap:anywhere;}
.neo-nav__badge{flex:0 0 auto;font-size:var(--text-micro);font-weight:var(--weight-bold);font-variant-numeric:tabular-nums;
  background:var(--cream);color:var(--navy-800);border-radius:var(--radius-pill);min-width:18px;height:18px;
  display:inline-flex;align-items:center;justify-content:center;padding:0 5px;}
.neo-nav__badge--muted{background:var(--shell-raised);color:var(--text-on-navy);}

/* ---- Breadcrumb ---- */
.neo-crumb{font-family:var(--font-sans);display:flex;align-items:center;gap:var(--space-1);font-size:var(--text-sm);
  flex-wrap:wrap;color:var(--text-muted);}
.neo-crumb a,.neo-crumb__item{color:var(--text-muted);text-decoration:none;border-radius:var(--radius-xs);padding:1px 3px;}
.neo-crumb a:hover{color:var(--text-link);text-decoration:underline;}
.neo-crumb__sep{color:var(--text-subtle);display:inline-flex;}
.neo-crumb__item--current{color:var(--text-strong);font-weight:var(--weight-semibold);}

/* ---- SearchField (global, in navy header) ---- */
.neo-search{position:relative;display:flex;align-items:center;flex:0 1 360px;}
.neo-search svg{position:absolute;left:var(--space-3);color:var(--text-on-navy-subtle);pointer-events:none;}
.neo-search input{font-family:inherit;font-size:var(--text-sm);height:var(--control-h-sm);width:100%;
  padding:0 var(--space-3) 0 calc(var(--space-3)*2 + 16px);border:var(--border-width) solid var(--shell-border);
  border-radius:var(--radius-md);background:var(--shell-deep);color:var(--text-on-navy);box-sizing:border-box;
  transition:border-color var(--motion-fast),box-shadow var(--motion-fast);}
.neo-search input::placeholder{color:var(--text-on-navy-subtle);}
.neo-search input:focus{outline:none;border-color:var(--cream-dim);box-shadow:var(--focus-ring-on-navy);}
.neo-search--light input{background:var(--surface-card);color:var(--text-body);border-color:var(--border-strong);}
.neo-search--light svg{color:var(--text-subtle);}
.neo-search__kbd{position:absolute;right:var(--space-2);font-family:var(--font-mono);font-size:10px;color:var(--text-on-navy-subtle);
  border:var(--border-width) solid var(--shell-border);border-radius:var(--radius-xs);padding:1px 5px;}

/* ---- Avatar ---- */
.neo-avatar{display:inline-flex;align-items:center;justify-content:center;border-radius:var(--radius-pill);
  background:var(--navy-500);color:var(--cream);font-weight:var(--weight-semibold);font-family:var(--font-sans);
  overflow:hidden;flex:0 0 auto;line-height:1;}
.neo-avatar img{width:100%;height:100%;object-fit:cover;}
.neo-avatar--sm{width:28px;height:28px;font-size:var(--text-caption);}
.neo-avatar--md{width:36px;height:36px;font-size:var(--text-sm);}
.neo-avatar--lg{width:44px;height:44px;font-size:var(--text-base);}
.neo-ident{display:inline-flex;align-items:center;gap:var(--space-3);}
.neo-ident__text{display:flex;flex-direction:column;min-width:0;line-height:1.25;}
.neo-ident__name{font-size:var(--text-sm);font-weight:var(--weight-semibold);overflow-wrap:anywhere;}
.neo-ident__sub{font-size:var(--text-micro);opacity:0.72;}

/* ---- RoleBadge ---- */
.neo-role{font-family:var(--font-sans);display:inline-flex;align-items:center;gap:5px;font-size:var(--text-micro);
  font-weight:var(--weight-semibold);border-radius:var(--radius-sm);
  padding:2px var(--space-2);border:var(--border-width) solid;}
.neo-role--operator{background:var(--info-surface);color:var(--info-text);border-color:var(--info-border);}
.neo-role--admin{background:var(--cream);color:var(--navy-800);border-color:var(--cream-deep);}
.neo-role--onnavy.neo-role--operator{background:rgba(45,108,168,0.25);color:#cfe0f0;border-color:rgba(45,108,168,0.5);}
.neo-role__dot{width:5px;height:5px;border-radius:50%;background:currentColor;}
@media (max-width:760px){
  .neo-shell{grid-template-columns:1fr;grid-template-rows:52px 48px auto minmax(0,1fr);
    grid-template-areas:"brand" "header" "side" "main";height:100%;overflow:hidden;}
  .neo-shell__brand{height:52px;padding:0 var(--space-4);border-right:0;}
  .neo-shell__brand-neo{font-size:var(--text-title);letter-spacing:2.5px;}
  .neo-shell__brand-sub{font-size:8px;letter-spacing:2.5px;}
  .neo-shell__header{height:48px;padding:0 var(--space-3);gap:var(--space-2);}
  .neo-shell__header .neo-role{display:none;}
  .neo-shell__header .neo-ident__text{display:none;}
  .neo-shell__side{padding:var(--space-2) var(--space-3);border-right:0;border-bottom:var(--border-width) solid var(--shell-border);
    flex-direction:row;align-items:center;gap:var(--space-2);overflow-x:auto;overflow-y:hidden;}
  .neo-shell__side-group,.shell-statusarea{display:none;}
  .neo-nav{width:auto;min-height:38px;flex:0 0 auto;padding:var(--space-2) var(--space-3);}
  .neo-nav--active{box-shadow:inset 0 -2px 0 var(--cream);}
  .neo-shell__main{padding:var(--space-3);min-width:0;overflow:auto;}
}
`;
  const s = document.createElement("style");
  s.id = "neo-nav-styles";
  s.textContent = css;
  document.head.appendChild(s);
}
Object.assign(__ds_scope, { ensureNavStyles });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/navigation/navStyles.js", error: String((e && e.message) || e) }); }

// components/navigation/AppShell.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * AppShell — the navy cockpit frame: a cream-wordmark brand block, a navy
 * header (global search + identity), a navy sidebar (nav), and a light content
 * area. Compose with NavItem, SearchField, Avatar, RoleBadge.
 */
function AppShell({
  brand = "NEO",
  brandSub = "COCKPIT 2.0",
  header = null,
  sidebar = null,
  className = "",
  children,
  ...rest
}) {
  __ds_scope.ensureNavStyles();
  return /*#__PURE__*/React.createElement("div", _extends({
    className: `neo-shell ${className}`.trim()
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: "neo-shell__brand"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "neo-shell__brand-neo"
  }, brand), /*#__PURE__*/React.createElement("div", {
    className: "neo-shell__brand-sub"
  }, brandSub))), /*#__PURE__*/React.createElement("header", {
    className: "neo-shell__header"
  }, header), /*#__PURE__*/React.createElement("nav", {
    className: "neo-shell__side"
  }, sidebar), /*#__PURE__*/React.createElement("main", {
    className: "neo-shell__main"
  }, children));
}
Object.assign(__ds_scope, { AppShell });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/navigation/AppShell.jsx", error: String((e && e.message) || e) }); }

// components/navigation/Avatar.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function initials(name = "") {
  return name.trim().split(/\s+/).slice(0, 2).map(p => p[0]).join("").toUpperCase();
}

/**
 * Avatar — round identity mark from initials or an image. Optionally pairs with
 * a name + sub-line (e.g. role) via the `name`/`sub` props.
 */
function Avatar({
  name = "",
  src = null,
  size = "md",
  sub = null,
  color = null,
  onNavy = false,
  className = "",
  ...rest
}) {
  __ds_scope.ensureNavStyles();
  const av = /*#__PURE__*/React.createElement("span", {
    className: `neo-avatar neo-avatar--${size}`,
    style: color ? {
      background: color
    } : undefined,
    "aria-hidden": !!sub
  }, src ? /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: name
  }) : initials(name));
  if (!name && !sub) return av;
  if (!sub) return /*#__PURE__*/React.createElement("span", _extends({
    title: name
  }, rest), av);
  return /*#__PURE__*/React.createElement("span", _extends({
    className: `neo-ident ${className}`.trim(),
    style: onNavy ? {
      color: "var(--text-on-navy)"
    } : undefined
  }, rest), av, /*#__PURE__*/React.createElement("span", {
    className: "neo-ident__text"
  }, /*#__PURE__*/React.createElement("span", {
    className: "neo-ident__name"
  }, name), /*#__PURE__*/React.createElement("span", {
    className: "neo-ident__sub"
  }, sub)));
}
Object.assign(__ds_scope, { Avatar });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/navigation/Avatar.jsx", error: String((e && e.message) || e) }); }

// components/navigation/Breadcrumb.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Sep = /*#__PURE__*/React.createElement("span", {
  className: "neo-crumb__sep",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "m9 18 6-6-6-6"
})));

/**
 * Breadcrumb — location trail. Pass `items` as { label, href? }; the last item
 * renders as the current page. `label` names the landmark (#890).
 */
function Breadcrumb({
  items = [],
  label = "Brotkrumen",
  className = "",
  ...rest
}) {
  __ds_scope.ensureNavStyles();
  return /*#__PURE__*/React.createElement("nav", _extends({
    className: `neo-crumb ${className}`.trim(),
    "aria-label": label
  }, rest), items.map((it, i) => {
    const last = i === items.length - 1;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: i
    }, last ? /*#__PURE__*/React.createElement("span", {
      className: "neo-crumb__item neo-crumb__item--current",
      "aria-current": "page"
    }, it.label) : it.href ? /*#__PURE__*/React.createElement("a", {
      href: it.href
    }, it.label) : /*#__PURE__*/React.createElement("span", {
      className: "neo-crumb__item"
    }, it.label), !last && Sep);
  }));
}
Object.assign(__ds_scope, { Breadcrumb });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/navigation/Breadcrumb.jsx", error: String((e && e.message) || e) }); }

// components/navigation/NavItem.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * NavItem — a sidebar navigation item for the navy shell, with default / hover
 * / active states and an optional count badge (e.g. open requests). Renders as
 * <a> when `href` is given, else <button>.
 */
function NavItem({
  icon = null,
  label,
  active = false,
  badge = null,
  badgeMuted = false,
  href,
  className = "",
  children,
  ...rest
}) {
  __ds_scope.ensureNavStyles();
  const Tag = href ? "a" : "button";
  return /*#__PURE__*/React.createElement(Tag, _extends({
    href: href,
    type: href ? undefined : "button",
    className: `neo-nav ${active ? "neo-nav--active" : ""} ${className}`.trim(),
    "aria-current": active ? "page" : undefined
  }, rest), icon && /*#__PURE__*/React.createElement("span", {
    className: "neo-nav__ic",
    "aria-hidden": "true"
  }, icon), /*#__PURE__*/React.createElement("span", {
    className: "neo-nav__label"
  }, label || children), badge != null && /*#__PURE__*/React.createElement("span", {
    className: `neo-nav__badge ${badgeMuted ? "neo-nav__badge--muted" : ""}`
  }, badge));
}
Object.assign(__ds_scope, { NavItem });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/navigation/NavItem.jsx", error: String((e && e.message) || e) }); }

// components/navigation/RoleBadge.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * RoleBadge — marks the signed-in user's role (Operator / Admin). Admin uses
 * the cream accent; Operator uses the calm info tone. `onNavy` adapts colors
 * for the navy header.
 */
function RoleBadge({
  role = "operator",
  label = null,
  onNavy = false,
  className = "",
  ...rest
}) {
  __ds_scope.ensureNavStyles();
  const text = label || (role === "admin" ? "Admin" : "Operator");
  return /*#__PURE__*/React.createElement("span", _extends({
    className: `neo-role neo-role--${role} ${onNavy ? "neo-role--onnavy" : ""} ${className}`.trim()
  }, rest), /*#__PURE__*/React.createElement("span", {
    className: "neo-role__dot",
    "aria-hidden": "true"
  }), text);
}
Object.assign(__ds_scope, { RoleBadge });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/navigation/RoleBadge.jsx", error: String((e && e.message) || e) }); }

// components/navigation/SearchField.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Icon = /*#__PURE__*/React.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "11",
  cy: "11",
  r: "7"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21 21-4.3-4.3"
}));

/**
 * SearchField — the global search input. Defaults to the navy header treatment;
 * pass `light` for use on a light surface. Optional keyboard hint (e.g. ⌘K).
 */
function SearchField({
  value,
  onChange,
  placeholder = "Anfragen, Kunden, Belege durchsuchen…",
  light = false,
  kbd = null,
  className = "",
  ...rest
}) {
  __ds_scope.ensureNavStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: `neo-search ${light ? "neo-search--light" : ""} ${className}`.trim()
  }, Icon, /*#__PURE__*/React.createElement("input", _extends({
    type: "search",
    value: value,
    placeholder: placeholder,
    "aria-label": "Globale Suche",
    onChange: e => onChange && onChange(e.target.value)
  }, rest)), kbd && /*#__PURE__*/React.createElement("span", {
    className: "neo-search__kbd"
  }, kbd));
}
Object.assign(__ds_scope, { SearchField });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/navigation/SearchField.jsx", error: String((e && e.message) || e) }); }

// components/status/statusStyles.js
try { (() => {
/* Shared style injection + tone helpers for NEO status/meta components. */

let _injected = false;
function ensureStatusStyles() {
  if (_injected || typeof document === "undefined") return;
  _injected = true;
  const css = `
/* ---- StatusPill ---- */
.neo-pill{font-family:var(--font-sans);display:inline-flex;align-items:center;gap:var(--space-2);
  font-size:var(--text-caption);font-weight:var(--weight-semibold);line-height:1;border-radius:var(--radius-pill);
  padding:5px var(--space-3);white-space:nowrap;border:var(--border-width) solid transparent;letter-spacing:0.01em;}
.neo-pill--sm{font-size:var(--text-micro);padding:3px var(--space-2);}
.neo-pill__dot{width:7px;height:7px;border-radius:50%;background:currentColor;flex:0 0 auto;}
.neo-pill__ic{display:inline-flex;margin:-1px 0;}
/* soft (default) */
.neo-pill--soft.t-neutral{background:var(--neutral-surface);color:var(--neutral-text);border-color:var(--neutral-border);}
.neo-pill--soft.t-info{background:var(--info-surface);color:var(--info-text);border-color:var(--info-border);}
.neo-pill--soft.t-success{background:var(--success-surface);color:var(--success-text);border-color:var(--success-border);}
.neo-pill--soft.t-warning{background:var(--warning-surface);color:var(--warning-text);border-color:var(--warning-border);}
.neo-pill--soft.t-danger{background:var(--danger-surface);color:var(--danger-text);border-color:var(--danger-border);}
/* solid (high emphasis, e.g. live send-state) */
.neo-pill--solid.t-neutral{background:var(--warm-600);color:#fff;}
.neo-pill--solid.t-info{background:var(--info-500);color:#fff;}
.neo-pill--solid.t-success{background:var(--success-500);color:#fff;}
.neo-pill--solid.t-warning{background:var(--warning-500);color:#fff;}
.neo-pill--solid.t-danger{background:var(--danger-500);color:#fff;}
/* outline */
.neo-pill--outline{background:transparent;}
.neo-pill--outline.t-neutral{color:var(--neutral-text);border-color:var(--neutral-border);}
.neo-pill--outline.t-info{color:var(--info-text);border-color:var(--info-border);}
.neo-pill--outline.t-success{color:var(--success-text);border-color:var(--success-border);}
.neo-pill--outline.t-warning{color:var(--warning-text);border-color:var(--warning-border);}
.neo-pill--outline.t-danger{color:var(--danger-text);border-color:var(--danger-border);}

/* ---- Tag / chip ---- */
.neo-tag{font-family:var(--font-sans);display:inline-flex;align-items:center;gap:var(--space-2);
  font-size:var(--text-caption);font-weight:var(--weight-medium);color:var(--text-body);background:var(--surface-sunken);
  border:var(--border-width) solid var(--border-subtle);border-radius:var(--radius-sm);padding:4px var(--space-2);line-height:1.2;}
.neo-tag--accent{background:var(--navy-50);border-color:var(--navy-100);color:var(--navy-700);}
.neo-tag__x{display:inline-flex;cursor:pointer;color:var(--text-subtle);border-radius:var(--radius-xs);margin:-2px -2px -2px 0;padding:2px;}
.neo-tag__x:hover{color:var(--text-strong);background:var(--surface-active);}

/* ---- ConfidenceIndicator ---- */
.neo-conf{font-family:var(--font-sans);display:inline-flex;align-items:center;gap:var(--space-2);font-size:var(--text-caption);}
.neo-conf__bars{display:inline-flex;gap:2px;align-items:flex-end;height:14px;}
.neo-conf__bar{width:4px;border-radius:1px;background:var(--warm-300);}
.neo-conf__bar.on{background:var(--_c,var(--success-500));}
.neo-conf__val{font-variant-numeric:tabular-nums;font-weight:var(--weight-semibold);color:var(--text-body);}
.neo-conf__lbl{color:var(--text-muted);}

/* ---- EvidenceCallout ---- */
.neo-evid{font-family:var(--font-sans);border:var(--border-width) solid var(--border-subtle);
  border-color:var(--navy-100);border-radius:var(--radius-sm);background:var(--surface-sunken);
  padding:var(--space-3) var(--space-4);display:flex;flex-direction:column;gap:var(--space-2);max-width:520px;}
.neo-evid__head{display:flex;align-items:center;gap:var(--space-2);font-size:var(--text-caption);font-weight:var(--weight-semibold);
  color:var(--text-subtle);}
.neo-evid__quote{font-size:var(--text-sm);line-height:var(--leading-normal);color:var(--text-strong);
  font-style:italic;overflow-wrap:anywhere;border:0;margin:0;padding:0;}
.neo-evid__quote::before{content:"\\201E";}.neo-evid__quote::after{content:"\\201C";}
.neo-evid__src{display:flex;align-items:center;gap:var(--space-2);font-size:var(--text-micro);color:var(--text-muted);
  font-family:var(--font-mono);}
.neo-evid__src b{color:var(--text-body);font-weight:var(--weight-medium);font-family:var(--font-sans);}

/* ---- VersionStamp ---- */
.neo-vstamp{font-family:var(--font-mono);font-size:var(--text-micro);color:var(--text-muted);
  display:inline-flex;align-items:center;gap:var(--space-2);background:var(--surface-sunken);
  border:var(--border-width) solid var(--border-subtle);border-radius:var(--radius-xs);padding:2px var(--space-2);}
.neo-vstamp b{color:var(--text-body);font-weight:var(--weight-medium);}
.neo-vstamp__ic{display:inline-flex;color:var(--text-subtle);}
`;
  const s = document.createElement("style");
  s.id = "neo-status-styles";
  s.textContent = css;
  document.head.appendChild(s);
}

/* Canonical tone mapping for the three NEO status vocabularies. Components may
   pass `tone` directly; these maps document the intended assignment. */
const REQUEST_LIFECYCLE = {
  neu: {
    tone: "info",
    label: "Neu"
  },
  extrahiert: {
    tone: "info",
    label: "Extrahiert"
  },
  in_pruefung: {
    tone: "warning",
    label: "In Prüfung"
  },
  rueckfrage_offen: {
    tone: "warning",
    label: "Rückfrage offen"
  },
  entwurf_bereit: {
    tone: "info",
    label: "Entwurf bereit"
  },
  freigegeben: {
    tone: "success",
    label: "Freigegeben"
  },
  gesendet: {
    tone: "success",
    label: "Gesendet"
  },
  onlineshop: {
    tone: "neutral",
    label: "Onlineshop (<30)"
  },
  abgelehnt: {
    tone: "danger",
    label: "Abgelehnt"
  },
  archiviert: {
    tone: "neutral",
    label: "Archiviert"
  }
};
const SEND_STATE = {
  gesperrt: {
    tone: "neutral",
    label: "Versand gesperrt"
  },
  bereit: {
    tone: "info",
    label: "Sendebereit"
  },
  in_versand: {
    tone: "warning",
    label: "Im Versand"
  },
  zugestellt: {
    tone: "success",
    label: "Zugestellt"
  },
  fehler: {
    tone: "danger",
    label: "Zustellung fehlgeschlagen"
  }
};
const FACT_STATUS = {
  verifiziert: {
    tone: "success",
    label: "Verifiziert"
  },
  abgeleitet: {
    tone: "info",
    label: "Abgeleitet"
  },
  angenommen: {
    tone: "info",
    label: "Angenommen"
  },
  unsicher: {
    tone: "warning",
    label: "Unsicher"
  },
  fehlend: {
    tone: "warning",
    label: "Fehlend"
  },
  widerspruch: {
    tone: "danger",
    label: "Widerspruch"
  },
  nicht_belegt: {
    tone: "danger",
    label: "Ohne Beleg"
  }
};
Object.assign(__ds_scope, { ensureStatusStyles, REQUEST_LIFECYCLE, SEND_STATE, FACT_STATUS });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/status/statusStyles.js", error: String((e && e.message) || e) }); }

// components/status/ConfidenceIndicator.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * ConfidenceIndicator — a calm 4-bar meter for an extraction confidence score
 * (0–1). Colour shifts low→high (warning→success); never a bare percentage.
 */
function ConfidenceIndicator({
  value = 0,
  showValue = true,
  label = null,
  className = "",
  ...rest
}) {
  __ds_scope.ensureStatusStyles();
  const v = Math.max(0, Math.min(1, value));
  const filled = Math.round(v * 4);
  const color = v >= 0.8 ? "var(--success-500)" : v >= 0.5 ? "var(--warning-500)" : "var(--danger-500)";
  const heights = [6, 9, 12, 14];
  return /*#__PURE__*/React.createElement("span", _extends({
    className: `neo-conf ${className}`.trim(),
    title: `Konfidenz ${Math.round(v * 100)}%`
  }, rest), /*#__PURE__*/React.createElement("span", {
    className: "neo-conf__bars",
    style: {
      "--_c": color
    },
    "aria-hidden": "true"
  }, heights.map((h, i) => /*#__PURE__*/React.createElement("span", {
    key: i,
    className: `neo-conf__bar ${i < filled ? "on" : ""}`,
    style: {
      height: h
    }
  }))), showValue && /*#__PURE__*/React.createElement("span", {
    className: "neo-conf__val"
  }, Math.round(v * 100), "%"), label && /*#__PURE__*/React.createElement("span", {
    className: "neo-conf__lbl"
  }, label));
}
Object.assign(__ds_scope, { ConfidenceIndicator });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/status/ConfidenceIndicator.jsx", error: String((e && e.message) || e) }); }

// components/status/EvidenceCallout.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const QuoteIcon = /*#__PURE__*/React.createElement("svg", {
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 7H3v6h4v-2H5a2 2 0 0 1 2-2V7Zm10 0h-4v6h4v-2h-2a2 2 0 0 1 2-2V7Z"
}));

/**
 * EvidenceCallout — shows a VERBATIM source quote plus its source type, the
 * provenance unit behind every extracted fact. Read-only, never editable; the
 * quote is shown exactly as it appeared in the source.
 */
function EvidenceCallout({
  quote,
  sourceType = "E-Mail-Text",
  sourceRef = null,
  heading = "Beleg",
  className = "",
  ...rest
}) {
  __ds_scope.ensureStatusStyles();
  return /*#__PURE__*/React.createElement("figure", _extends({
    className: `neo-evid ${className}`.trim()
  }, rest), /*#__PURE__*/React.createElement("figcaption", {
    className: "neo-evid__head"
  }, QuoteIcon, /*#__PURE__*/React.createElement("span", null, heading)), /*#__PURE__*/React.createElement("blockquote", {
    className: "neo-evid__quote"
  }, quote), /*#__PURE__*/React.createElement("div", {
    className: "neo-evid__src"
  }, /*#__PURE__*/React.createElement("span", null, "Quelle:\xA0", /*#__PURE__*/React.createElement("b", null, sourceType)), sourceRef && /*#__PURE__*/React.createElement("span", {
    style: {
      opacity: 0.7
    }
  }, "\xB7 ", sourceRef)));
}
Object.assign(__ds_scope, { EvidenceCallout });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/status/EvidenceCallout.jsx", error: String((e && e.message) || e) }); }

// components/status/StatusPill.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * StatusPill — one badge that covers every NEO status vocabulary (the 10-value
 * request lifecycle, the 5-value send-state and the 7-value fact-status) by
 * mapping each onto five tones: neutral / info / warning / danger / success.
 * Pass `tone` + `label` directly, or import a vocabulary map from statusStyles.
 */
function StatusPill({
  tone = "neutral",
  label,
  variant = "soft",
  size = "md",
  dot = true,
  icon = null,
  className = "",
  children,
  ...rest
}) {
  __ds_scope.ensureStatusStyles();
  return /*#__PURE__*/React.createElement("span", _extends({
    className: ["neo-pill", `neo-pill--${variant}`, `t-${tone}`, size === "sm" ? "neo-pill--sm" : "", className].filter(Boolean).join(" ")
  }, rest), icon ? /*#__PURE__*/React.createElement("span", {
    className: "neo-pill__ic",
    "aria-hidden": "true"
  }, icon) : dot && /*#__PURE__*/React.createElement("span", {
    className: "neo-pill__dot",
    "aria-hidden": "true"
  }), label || children);
}
Object.assign(__ds_scope, { StatusPill });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/status/StatusPill.jsx", error: String((e && e.message) || e) }); }

// components/status/Tag.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const X = /*#__PURE__*/React.createElement("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2.2",
  strokeLinecap: "round",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 6 6 18M6 6l12 12"
}));

/**
 * Tag — a small chip for attributes, filters and selections (e.g. "vegetarisch",
 * "Messe", "Hamburg"). Optional removable variant for active filters.
 */
function Tag({
  label,
  accent = false,
  onRemove,
  icon = null,
  className = "",
  children,
  ...rest
}) {
  __ds_scope.ensureStatusStyles();
  return /*#__PURE__*/React.createElement("span", _extends({
    className: `neo-tag ${accent ? "neo-tag--accent" : ""} ${className}`.trim()
  }, rest), icon && /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    style: {
      display: "inline-flex"
    }
  }, icon), label || children, onRemove && /*#__PURE__*/React.createElement("span", {
    className: "neo-tag__x",
    role: "button",
    tabIndex: 0,
    "aria-label": "Entfernen",
    onClick: onRemove,
    onKeyDown: e => (e.key === "Enter" || e.key === " ") && onRemove()
  }, X));
}
Object.assign(__ds_scope, { Tag });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/status/Tag.jsx", error: String((e && e.message) || e) }); }

// components/status/VersionStamp.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Tag = /*#__PURE__*/React.createElement("svg", {
  width: "11",
  height: "11",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 7v5l9 9 5-5-9-9H3Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "7",
  cy: "11",
  r: "1.2",
  fill: "currentColor"
}));

/**
 * VersionStamp — a monospace revision / ruleset-version marker (e.g. the
 * versioned `ruleset_version` on every decision, or a request revision).
 */
function VersionStamp({
  label = "Regelsatz",
  value,
  icon = true,
  className = "",
  ...rest
}) {
  __ds_scope.ensureStatusStyles();
  return /*#__PURE__*/React.createElement("span", _extends({
    className: `neo-vstamp ${className}`.trim()
  }, rest), icon && /*#__PURE__*/React.createElement("span", {
    className: "neo-vstamp__ic"
  }, Tag), /*#__PURE__*/React.createElement("span", null, label), /*#__PURE__*/React.createElement("b", null, value));
}
Object.assign(__ds_scope, { VersionStamp });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/status/VersionStamp.jsx", error: String((e && e.message) || e) }); }

// components/timeline/TimelineItem.jsx
try { (() => {
let _injected = false;
function ensureTimelineStyles() {
  if (_injected || typeof document === "undefined") return;
  _injected = true;
  const css = `
.neo-tl{font-family:var(--font-sans);display:flex;gap:var(--space-3);position:relative;}
.neo-tl__rail{flex:0 0 auto;display:flex;flex-direction:column;align-items:center;width:34px;}
.neo-tl__dot{width:34px;height:34px;border-radius:var(--radius-pill);display:inline-flex;align-items:center;justify-content:center;
  flex:0 0 auto;border:var(--border-width-3) solid var(--surface-page);box-shadow:0 0 0 1px var(--border-default);
  background:var(--surface-card);color:var(--text-muted);z-index:1;}
.neo-tl__line{flex:1 1 auto;width:2px;background:var(--border-default);margin:2px 0;min-height:8px;}
.neo-tl:last-child .neo-tl__line{display:none;}
.neo-tl__body{flex:1;min-width:0;padding-bottom:var(--space-5);}
.neo-tl__head{display:flex;align-items:baseline;gap:var(--space-2);flex-wrap:wrap;}
.neo-tl__actor{font-size:var(--text-sm);font-weight:var(--weight-semibold);color:var(--text-strong);overflow-wrap:anywhere;}
.neo-tl__verb{font-size:var(--text-sm);color:var(--text-muted);}
.neo-tl__time{font-size:var(--text-caption);color:var(--text-subtle);font-variant-numeric:tabular-nums;margin-left:auto;white-space:nowrap;}
.neo-tl__card{margin-top:var(--space-2);border:var(--border-width) solid var(--border-subtle);border-radius:var(--radius-md);
  padding:var(--space-3) var(--space-4);font-size:var(--text-sm);line-height:var(--leading-normal);color:var(--text-body);
  overflow-wrap:anywhere;background:var(--surface-card);}
.neo-tl__card--in{background:var(--surface-sunken);}
.neo-tl__card--out{background:var(--info-surface);border-color:var(--info-border);}
.neo-tl__meta{margin-top:var(--space-2);display:flex;gap:var(--space-2);flex-wrap:wrap;align-items:center;}
/* dot tones */
.neo-tl__dot--in{color:var(--text-muted);}
.neo-tl__dot--out{background:var(--navy-700);color:var(--cream);box-shadow:0 0 0 1px var(--navy-700);}
.neo-tl__dot--decision{background:var(--info-surface);color:var(--info-600);box-shadow:0 0 0 1px var(--info-border);}
.neo-tl__dot--success{background:var(--success-surface);color:var(--success-600);box-shadow:0 0 0 1px var(--success-border);}
.neo-tl__dot--warning{background:var(--warning-surface);color:var(--warning-600);box-shadow:0 0 0 1px var(--warning-border);}
.neo-tl__dot--danger{background:var(--danger-surface);color:var(--danger-600);box-shadow:0 0 0 1px var(--danger-border);}
.neo-tl__dot--audit{background:var(--surface-card);color:var(--text-subtle);}
`;
  const s = document.createElement("style");
  s.id = "neo-timeline-styles";
  s.textContent = css;
  document.head.appendChild(s);
}
const ICONS = {
  in: /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 4h16v16H4z",
    opacity: "0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 7-10 6L2 7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "2",
    y: "5",
    width: "20",
    height: "14",
    rx: "2"
  })),
  out: /*#__PURE__*/React.createElement("svg", {
    width: "15",
    height: "15",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22 2-7 20-4-9-9-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 2 11 13"
  })),
  decision: /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 11l3 3 8-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h9"
  })),
  success: /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 12 3 3 5-6"
  })),
  warning: /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 9v4M12 17h.01"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  })),
  danger: /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8v5M12 16h.01"
  })),
  audit: /*#__PURE__*/React.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "2.5"
  }))
};

/**
 * TimelineItem — one entry in a request's combined email-thread + audit log.
 * `type` sets the marker tone/icon: in / out (email), decision, success,
 * warning, danger, audit. Wrap several in a column; the connecting line is
 * drawn automatically (hidden on the last via :last-child).
 */
function TimelineItem({
  type = "audit",
  actor,
  verb = null,
  time = null,
  icon,
  card = null,
  meta = null,
  className = "",
  children
}) {
  ensureTimelineStyles();
  const ic = icon !== undefined ? icon : ICONS[type] || ICONS.audit;
  const cardTone = type === "in" ? "neo-tl__card--in" : type === "out" ? "neo-tl__card--out" : "";
  const content = card != null ? card : children;
  return /*#__PURE__*/React.createElement("div", {
    className: `neo-tl ${className}`.trim()
  }, /*#__PURE__*/React.createElement("div", {
    className: "neo-tl__rail"
  }, /*#__PURE__*/React.createElement("span", {
    className: `neo-tl__dot neo-tl__dot--${type}`,
    "aria-hidden": "true"
  }, ic), /*#__PURE__*/React.createElement("span", {
    className: "neo-tl__line"
  })), /*#__PURE__*/React.createElement("div", {
    className: "neo-tl__body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "neo-tl__head"
  }, actor && /*#__PURE__*/React.createElement("span", {
    className: "neo-tl__actor"
  }, actor), verb && /*#__PURE__*/React.createElement("span", {
    className: "neo-tl__verb"
  }, verb), time && /*#__PURE__*/React.createElement("span", {
    className: "neo-tl__time"
  }, time)), content != null && /*#__PURE__*/React.createElement("div", {
    className: `neo-tl__card ${cardTone}`.trim()
  }, content), meta && /*#__PURE__*/React.createElement("div", {
    className: "neo-tl__meta"
  }, meta)));
}
Object.assign(__ds_scope, { TimelineItem });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/timeline/TimelineItem.jsx", error: String((e && e.message) || e) }); }

__ds_ns.Button = __ds_scope.Button;

__ds_ns.SendButton = __ds_scope.SendButton;

__ds_ns.Card = __ds_scope.Card;

__ds_ns.CollapsibleSection = __ds_scope.CollapsibleSection;

__ds_ns.DiffView = __ds_scope.DiffView;

__ds_ns.SplitPanel = __ds_scope.SplitPanel;

__ds_ns.Tabs = __ds_scope.Tabs;

__ds_ns.DataTable = __ds_scope.DataTable;

__ds_ns.FilterBar = __ds_scope.FilterBar;

__ds_ns.Pagination = __ds_scope.Pagination;

__ds_ns.Banner = __ds_scope.Banner;

__ds_ns.SYSTEM_BANNERS = __ds_scope.SYSTEM_BANNERS;

__ds_ns.Dialog = __ds_scope.Dialog;

__ds_ns.ConfirmDialog = __ds_scope.ConfirmDialog;

__ds_ns.Tooltip = __ds_scope.Tooltip;

__ds_ns.Checkbox = __ds_scope.Checkbox;

__ds_ns.FormField = __ds_scope.FormField;

__ds_ns.Input = __ds_scope.Input;

__ds_ns.Radio = __ds_scope.Radio;

__ds_ns.Select = __ds_scope.Select;

__ds_ns.Switch = __ds_scope.Switch;

__ds_ns.Textarea = __ds_scope.Textarea;

__ds_ns.AppShell = __ds_scope.AppShell;

__ds_ns.Avatar = __ds_scope.Avatar;

__ds_ns.Breadcrumb = __ds_scope.Breadcrumb;

__ds_ns.NavItem = __ds_scope.NavItem;

__ds_ns.RoleBadge = __ds_scope.RoleBadge;

__ds_ns.SearchField = __ds_scope.SearchField;

__ds_ns.ConfidenceIndicator = __ds_scope.ConfidenceIndicator;

__ds_ns.EvidenceCallout = __ds_scope.EvidenceCallout;

__ds_ns.StatusPill = __ds_scope.StatusPill;

__ds_ns.Tag = __ds_scope.Tag;

__ds_ns.VersionStamp = __ds_scope.VersionStamp;

__ds_ns.REQUEST_LIFECYCLE = __ds_scope.REQUEST_LIFECYCLE;

__ds_ns.SEND_STATE = __ds_scope.SEND_STATE;

__ds_ns.FACT_STATUS = __ds_scope.FACT_STATUS;

__ds_ns.TimelineItem = __ds_scope.TimelineItem;

})();
